import $ from 'jquery';
import axios from 'axios';
import React, {Component} from 'react';
import uuidv1 from 'uuid/v1';
import JSZip, { forEach } from 'jszip';
import JSZipUtils from 'jszip-utils';
import {DamService} from '../../services/dam';
import {UserService} from '../../services/user';
import {WorkflowsService} from '../../services/workflows';
import {xmlBuilder} from '../../services/xml';
import './composer.css';
import {Compositions} from '../../containers';
import {RDP_TRANSLATE} from '../../translate/translate';
import RDP_CONFIG from '../../config';
import {Configurations, ElementEdit, ElementMessages, ElementActivities, Popup, Sidebar} from '../../components';
import replaceCompositionObjectsIds from "../../utils/replaceCompositionObjectsIds";
import Swal from 'sweetalert2';
import Url from "../../utils/url";
import getConnectorFromArray from "../../utils/getConnectorFromArray";
import { getTheme } from '../../utils/getTheme';
import { StructureProvider } from '../../hooks/context/structure';
import { CompositionProvider } from '../../hooks/context/composition';
import { ActionsMenu } from '../../components/actions-menu';
import { createObjectTable } from '../../utils/table';

export default class ViewComposer extends Component {
  constructor(props) {
    super(props);

    this.iaQuizContentInput = React.createRef();
    this.iaQuizContentTextarea = React.createRef();

    this.state = {
      "is_embed": this.props.match.path.search("/embed/") !== -1,
      "downloading": false,
      "opened_configurations": false,
      "opened_menu": false,
      "opened_help": false,
      "displayed_preloader": this.props.match.params.content_uid !== undefined,
      "structure": [],
      "enabled_element_edit_props": false,
      "enabled_element_message_object_uid": null,
      "redirect_to_preview": false,
      "redirect_to_home": false,
      "mirror_composition": null,
      "composition_backup": {},
      "composition": {
        "version": "1.1",
        "metadata": {
          "title": "Sem título",
          "description": "",
          "thumb": null,
          "tags": []
        },
        "interface": {
          "content_language": RDP_CONFIG.language,
          "index_option": "buttons",
          "font_family": "Lato",
          "show_summary": "disabled",
          "finish_btn": "disabled"
        },
        "structure": []
      },
      "labels": RDP_TRANSLATE[RDP_CONFIG.language]().composer,
      "google_fonts_render_modal": false,
      "google_fonts": null,
      "ia_render_text_modal": false,
      "ia_render_text_modal_preloader": false,
      "ia_render_create_text_modal": false,
      "ia_render_adapt_language_modal": false,
      "ia_language_suggestions": [],
      "ia_render_generate_examples_modal": false,
      "ia_examples_suggestions": [],
      "ia_render_organize_script_modal": false,
      "ia_script_suggestions": [],
      "ia_render_spellcheck_modal": false,
      "ia_spellcheck_errors": [],
      "ia_spellcheck_text": "",
      "ia_render_spellcheck_modal_preloader": false,
      "ia_element": null,
      "ia_index": null,
      "ia_render_quiz_modal": false,
      "ia_quiz_questions_length": 1,
      "ia_quiz_question_context": "composition",
      "ia_render_quiz_modal_preloader": false,
      "project_users": null,
      "render_versions_history": false,
      "first_version": null,
      "render_first_version_items": false,
      "second_version": null,
      "render_second_version_items": false,
      "versions": [],
      "can_send_object_messages": false,
      "render_activities": false,
      "can_edit_composition": true,
      "can_edit_video": true,
      "can_edit_audio": true,
      "can_edit_text": true,
      "can_edit_image": true,
      "render_composition_processes": false,
      "temp_processes_selected_first": null,
      "temp_processes_selected_last": null,
      "processes_selected_first": null,
      "processes_selected_last": null,
      "enabled_workflows": false,
      "structure_before_removed": null,
      "user_is_creator_viewer": false,
      "user_is_creator_colaborator": false
    }

    this.onClickSubitem = this.onClickSubitem.bind(this);
    this.onApplyTemplate = this.onApplyTemplate.bind(this);
    this.autoSize = this.autoSize.bind(this);
    this.onElementEditClose = this.onElementEditClose.bind(this);
    this.onElementEdit = this.onElementEdit.bind(this);
    this.onElementRemove = this.onElementRemove.bind(this);
    this.onElementChange = this.onElementChange.bind(this);
    this.onElementMoveDown = this.onElementMoveDown.bind(this);
    this.onElementMoveUp = this.onElementMoveUp.bind(this);
    this.onElementAdd = this.onElementAdd.bind(this);
    this.setUserEditorUid = this.setUserEditorUid.bind(this);
  }

  componentWillMount() {
    if (this.props.match.params.content_uid !== undefined) {
      // this.getUserRestrictions();
      this.getProcesses();
      this.getProjectUsers();
      this.getCompositionContent(this.props.match.params.content_uid)
      this.getCompositionVersions();
      this.dispatchConnectorStatusWorkflow()
      // .then(this.setUserEditorUid);
      this.getGoogleFonts();
    }
    this.redirectToLogin();
    this.getRoles();
  }

  getRoles() {
    var user = UserService.getUserDecoded();
    var roles = [];

    if (user !== null) {
      roles = user.role;
    }

    if (typeof roles === "string") {
      roles = [roles];
    }

    this.setState({
      "user_is_creator_viewer": roles.find(role => role === "CreatorViewer") !== undefined,
      "user_is_creator_colaborator": roles.find(role => role === "CreatorColaborator") !== undefined
    })
  }

  dispatchConnectorStatusWorkflow() {
    var enabledWorkflows = false;
    var connectors = UserService.getAllConnectors();
    for (var i = 0; i < connectors.length; i++) {
      var configuration = JSON.parse(connectors[i].configuration);
      if (configuration.name === "Workflow") {
        enabledWorkflows = true;
      };
    };

    this.setState({
      "enabled_workflows": enabledWorkflows
    });
  }

  hasConnectorWorflow() {
    var enabledWorkflows = false;
    var connectors = UserService.getAllConnectors();
    for (var i = 0; i < connectors.length; i++) {
      var configuration = JSON.parse(connectors[i].configuration);
      if (configuration.name === "Workflow") {
        enabledWorkflows = true;
      };
    };

    return enabledWorkflows;
  }

  async getProcesses() {
    if (this.hasConnectorWorflow()) {
      var processes = await WorkflowsService.getProcesses();
      this.setState({
        "processes": processes
      });
    }
  }

  retrieveAssignedProcesses() {
    const {
      composition,
    } = this.state;

    if (composition.workflows_required_first !== undefined) {
      this.setState({
        "temp_processes_selected_first": composition.workflows_required_first.uid
      })
    };

    if (composition.workflows_required_last !== undefined) {
      this.setState({
        "temp_processes_selected_last": composition.workflows_required_last.uid
      })
    };


    // composition.workflows_required_first = {
    //   "uid": temp_processes_selected_first,
    //   "properties": this.formatProperties(processes.find(item => item.uid === temp_processes_selected_first).properties)
    // };

    // composition.workflows_required_last = {
    //   "uid": temp_processes_selected_last,
    //   "properties": this.formatProperties(processes.find(item => item.uid === temp_processes_selected_last).properties)
    // };
  }

  async getUserRestrictions() {
    var restrictions = await UserService.getUserRestrictions();

    const user = UserService.getUserInfo();
    if (user.uid !== "ea536f89-7d84-ee11-8925-000d3a16db59") {
      var defaultRestriction = restrictions.find(item => item.name === "Default");
      if (defaultRestriction && defaultRestriction.type === "Write") {
        this.setState({
          "can_edit_composition": false,
          "can_edit_video": false,
          "can_edit_audio": false,
          "can_edit_text": false,
          "can_edit_image": false
        })
      }
    }

    var videoRestriction = restrictions.find(item => item.name === "video");
    if (videoRestriction && videoRestriction.type === "Write") {
      this.setState({
        "can_edit_video": true
      })
    }

    var audioRestriction = restrictions.find(item => item.name === "audio");
    if (audioRestriction && audioRestriction.type === "Write") {
      this.setState({
        "can_edit_audio": true
      })
    }

    var imageRestriction = restrictions.find(item => item.name === "image");
    if (imageRestriction && imageRestriction.type === "Write") {
      this.setState({
        "can_edit_image": true
      })
    }

    var textRestriction = restrictions.find(item => item.name === "text");
    if (textRestriction && textRestriction.type === "Write") {
      this.setState({
        "can_edit_text": true
      })
    }
  }

  async getCompositionVersions() {
    const userData = UserService.getUser();
    const accessToken = userData.access_token;
    const original = await DamService.getFileOriginalUid(this.props.match.params.content_uid, accessToken);
    const versions = await DamService.getFileVersions(original.original_uid, accessToken);

    for (var i = 0; i < versions.length; i++) {
      versions[i].label = `Versão ${i + 1}`;
    }

    this.setState({
      "versions": versions,
      "first_version": versions[0].content_uid,
      "second_version": versions[versions.length - 1].content_uid
    })
  }

  getIframeSrc(id) {
    var userData = UserService.getUser();
    var accessToken = userData.access_token;

    var options = {
      "activity":{
        "mime_type":"digitalpages/composer",
        "url": `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${id}&project_key=${RDP_CONFIG.projectKey}`
      },
      "access_token": accessToken
    }

    let domain = RDP_CONFIG.domain;
    if (domain === "api-euconquisto.azure-api.net") {
      domain = "content-euconquisto.azureedge.net";
    }

    var keyType = RDP_CONFIG.projectUid.length > 0 ? "p" : "d";
    var keyValue = keyType == "p" ? RDP_CONFIG.projectUid : RDP_CONFIG.directoryUid;

    var composerPlayer = `https://${domain}/product/learning_player/current/${RDP_CONFIG.projectKey}/${keyType}/${keyValue}/${RDP_CONFIG.apiEnv}/init?custom_options=${btoa(JSON.stringify(options))}`;

    return composerPlayer;
  }

  async getProjectUsers() {
    const userData = UserService.getUser();
    const accessToken = userData.access_token;
    var users = await UserService.getProjectUsers(accessToken);
    this.setState({
      "project_users": users
    })
  }

  getGoogleFonts() {
    var _this = this;

    DamService.getGoogleFonts().then(function (fonts) {
      _this.setState({
        "google_fonts": fonts
      })
    });
  }

  async getCompositionContent(id) {
    var _this = this;
    const userData = UserService.getUser();
    const context = { api_env : RDP_CONFIG.apiEnv, project_key : RDP_CONFIG.projectKey};
    const accessToken = userData.access_token;
    const canSendObjectMessages = await this.canSendObjectMessages();
    
    return new Promise(async (resolve) => {
      DamService.getContent(id, accessToken)
        .then(async (composition) => {  
          composition = this.adjustStructure(context, JSON.parse(composition), userData);
  
          const canDownload = await this.canDownloadComposition(composition);
  
          this.setState({
            "composition": composition,
            "composition_backup": JSON.parse(JSON.stringify(composition)),
            "can_download": canDownload,
            "can_send_object_messages": canSendObjectMessages,
            "displayed_preloader": false
          }, () => {
            _this.retrieveAssignedProcesses()
            resolve()
          })
        })
        .catch(function (error) {
          if (error && "status" in error) {
            window.location = window.location.origin + "/#/status/" + error.status;
          }
        });
    });
  }

  setUserEditorUid() {
    const {
      composition = {}
    } = this.state;
    const {
      metadata: {
        editor_uuid
      }
    } = composition;

    const userUuid = UserService.getUUid();

    if (editor_uuid === undefined) {
      composition.metadata.editor_uuid = userUuid;

      this.setState({
        "composition": composition
      }, () => {
        this.onSaveClick();
      });
    } else if (editor_uuid !== userUuid) {
      Swal.fire({
        title: this.state.labels.attention,
        text: this.state.labels.composition_being_edited,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#212b36',
        confirmButtonText: this.state.labels.yes,
        cancelButtonText: this.state.labels.no,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          composition.metadata.editor_uuid = userUuid;

          this.setState({
            "composition": composition
          }, () => {
            this.onSaveClick();
          });
        } else if (
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.redirectToHome();
        }
      });
    } else {
      // verifica se possui alterações locais e se sim, pergunta se deseja salvar
      const localComposition = DamService.getLocalContent(this.props.match.params.content_uid);
      if (localComposition) {
        Swal.fire({
          title: this.state.labels.local_changes,
          text: this.state.labels.save_changes_message,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#212b36',
          confirmButtonText: this.state.labels.save_changes,
          cancelButtonText: this.state.labels.discard_changes,
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            const content_uid = this.props.match.params.content_uid;

            this.setState({
              "composition": localComposition
            }, () => {
              this.onSaveClick().then(() => {
                DamService.removeLocalContent(content_uid);
                Swal.fire(
                  this.state.labels.saved,
                  this.state.labels.saved_message,
                  'success'
                );
              });
            });
          } else if (
            result.dismiss === Swal.DismissReason.cancel
          ) {
            DamService.removeLocalContent(this.props.match.params.content_uid);
          }
        })
      }
    }
  }

  async canDownloadComposition(composition)
  {
    let sameOrigin = false;
    let downloadEnabled = false;

    const project = UserService.getActiveProject();
    let connectors = project.connectors.filter(p => p.type === "Customization_1");

    const userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    const type = userData.type;
    const accessToken = userData.access_token;
    let authorization = type + " " + accessToken;

    if (RDP_CONFIG.directToken) {
      authorization = "Bearer " + RDP_CONFIG.directToken;
    }

    for(var connector of connectors)
    {
      try
      {
        const resp = await fetch(`https://${RDP_CONFIG.domain}/auth/v1.1/connector/uid/${connector.uid}`, {
          method: "GET",
          headers: {
            "Authorization": authorization,
            "Project-Key": RDP_CONFIG.projectKey,
            "Api-Env": RDP_CONFIG.apiEnv,
            "Content-Type": "application/json"
          }
        });

        var connectorInfo = await resp.json();
        let configuration = typeof connectorInfo.configuration === "string" ? JSON.parse(connectorInfo.configuration) : connectorInfo.configuration;
        let configs = configuration.configs;
        let composerConfigs = configs.find(c => c.uid === "composer") || {};

        if (composerConfigs && "value" in composerConfigs) {
          let values = JSON.parse(composerConfigs.value);

          let downloadConfig = values.find(c => c.uid === "enable_download") || [];

          if (downloadConfig && "value" in downloadConfig) {
            downloadEnabled = downloadConfig.value !== "false";
          }
        }

        if (downloadEnabled) break;
      }catch(e)
      {
        console.log(e);
      }
    }

    if(downloadEnabled){
      if ("origin" in composition) {
        sameOrigin = composition.origin.directory_uid === project.directory.uid &&
          composition.origin.project_uid === project.uid;
      }
    }

    return sameOrigin || downloadEnabled;
  }

  async canSendObjectMessages() {
    let sendMessagesEnabled = false;

    const project = UserService.getActiveProject();
    let connectors = project.connectors.filter(p => p.type === "Customization_1");

    const userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    const type = userData.type;
    const accessToken = userData.access_token;
    let authorization = type + " " + accessToken;

    if (RDP_CONFIG.directToken) {
      authorization = "Bearer " + RDP_CONFIG.directToken;
    }

    for(var connector of connectors) {
      try {
        const resp = await fetch(`https://${RDP_CONFIG.domain}/auth/v1.1/connector/uid/${connector.uid}`, {
          method: "GET",
          headers: {
            "Authorization": authorization,
            "Project-Key": RDP_CONFIG.projectKey,
            "Api-Env": RDP_CONFIG.apiEnv,
            "Content-Type": "application/json"
          }
        });

        var connectorInfo = await resp.json();
        let configuration = typeof connectorInfo.configuration === "string" ? JSON.parse(connectorInfo.configuration) : connectorInfo.configuration;
        let configs = configuration.configs;
        let composerConfigs = configs.find(c => c.uid === "composer") || {};

        if (composerConfigs && "value" in composerConfigs) {
          let values = JSON.parse(composerConfigs.value);

          let sendMessagesConfig = values.find(c => c.uid === "enable_object_messages") || [];

          if (sendMessagesConfig && "value" in sendMessagesConfig) {
            sendMessagesEnabled = Boolean(sendMessagesConfig.value);
            console.log("sendMessagesEnabled", sendMessagesEnabled);
          }
        }

        if (sendMessagesEnabled) break;
      } catch(e) {
        console.log(e);
      }
    }

    return sendMessagesEnabled;
  }

  adjustStructure(context, structure, userData)
  {
    if (!structure.assets) return structure;

    var originalJson = JSON.stringify(structure);
    var accessToken = userData ? userData.access_token : "";
    var mapReplaced = [];

    for (const index in structure.assets) {
      const url = structure.assets[index];

      if (url) {
        if (url.indexOf("/content") == -1 || url.indexOf("/storage/v") == -1) continue;

        if (mapReplaced.find(p=> p == url)) continue;

        var newUrl = url;
        if (newUrl.indexOf("api_env") == -1) newUrl += `&api_env=${context.api_env}`;
        if (newUrl.indexOf("project_key") == -1) newUrl += `&project_key=${context.project_key}`;

        originalJson = originalJson.replaceAll(url, newUrl);
        originalJson = originalJson.replaceAll("api-euconquisto.azure-api.net", "api.digitalpages.com.br");
        mapReplaced.push(url);
      }
    }

    structure = JSON.parse(originalJson);
    return structure;
  }

  redirectToLogin() {
    if (window.localStorage.getItem("rdp-composer-user-data") === null) {
      // window.location = window.location.origin + "/#/login/";
      window.location = window.location.origin + window.location.pathname + "#/login";
    };
  }

  onElementCopy(element, index) {
    var composition = this.state.composition;
    var structure = composition.structure;

    var obj = JSON.parse(JSON.stringify(element));

    obj = replaceCompositionObjectsIds({...obj});

    structure.splice(index + 1, 0, obj);

    composition.structure = structure;
    this.setState({
      "composition": composition
    })

    DamService.setLocalContent(composition, this.props.match.params.content_uid);
  }

  onElementOpenMessages(element) {
    this.setState({
      "enabled_element_message_object_uid": element.id
    })
  }

  onElementCloseMessages() {
    this.setState({
      "enabled_element_message_object_uid": null
    })
  }

  onElementEdit(element) {
    this.setState({
      "enabled_element_edit_props": true,
      "element_edit_props": element
    })
  }

  onElementRemove(element) {
    var composition = this.state.composition;
    var structure = composition.structure;
    const structureCopy = [...structure];

    structure = structure.filter(function (obj) {
      return element.id !== obj.id;
    });
    composition.structure = structure
    this.setState({
      "composition": composition,
      "structure_before_removed": JSON.stringify(structureCopy),
    });

    DamService.setLocalContent(composition, this.props.match.params.content_uid);
  }

  onElementMoveUp(index) {
    this.onElementMove(index, index - 1);
  }

  onElementMoveDown(index) {
    this.onElementMove(index, index + 1);
  }

  onElementMove(old_index, new_index) {
    var composition = this.state.composition;
    var structure = composition.structure;
    if (new_index >= structure.length) {
      var k = new_index - structure.length + 1;
      while (k--) {
        structure.push(undefined);
      }
    }
    structure.splice(new_index, 0, structure.splice(old_index, 1)[0]);

    composition.structure = structure;
    this.setState({
      "composition": composition
    })
  }

  onDispatchCompositionChange(newComposition) {
    const event = new CustomEvent('compositionChange', {
        detail: {
            newComposition
        },
    });

    document.dispatchEvent(event);
}

  onElementChange(element) {
    var composition = this.state.composition;
    var structure = composition.structure;
    for (var i = 0; i < structure.length; i++) {
      if (structure[i].id === element.id) {
        structure[i] = element;
      };
    };

    composition.structure = structure;
    this.setState({
      "composition": composition,
      "enabled_element_edit_props": false,
      "element_edit_props": null
    }, () => {
      this.onDispatchCompositionChange(composition)
    })
  }

  onElementEditClose() {
    this.setState({
      "enabled_element_edit_props": false,
      "element_edit_props": null
    })
  }

  onContentChange(index, content) {
    var composition = this.state.composition;
    var structure = composition.structure;
    structure[index] = content;
    composition.structure = structure;

    this.setState({
      "composition": composition
    })
    DamService.setLocalContent(composition, this.props.match.params.content_uid);
  }

  onMetadataChange(composition) {
    this.setState({
      "composition": composition
    })
    DamService.setLocalContent(composition, this.props.match.params.content_uid);
  }

  onElementAdd(index) {
    var composition = this.state.composition;
    var structure = composition.structure;

    structure = structure.filter(function(element) { return element.type != "temp-slot"; });

    structure.splice(index + 1, 0, {
      "id": uuidv1(),
      "type": "temp-slot",
      "text": this.state.labels.stage.choose_element_to_insert_above
    });

    composition.structure = structure;
    this.setState({
      "composition": composition
    })

    DamService.setLocalContent(composition, this.props.match.params.content_uid);
  }

  onClickSubitem(type) {
    var composition = this.state.composition;
    var structure = composition.structure;
    var obj;
    var hasTempSlot = null;

    for (var i = 0; i < structure.length; i++) {
      if (structure[i].type === "temp-slot") {
        hasTempSlot = i;
      };
    };

    if (type === "head-1") {
      obj = {
        "id": uuidv1(),
        "type": "head-1",
        "content_title": null,
        "primary_color": "#FFFFFF",
        "secondary_color": "#aa2c23",
        "category": '<p>Lorem ipsum dolor</p>',
        "background_image": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png",
        "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
        "avatar_border_color": "#00643e",
        "author_name": "H. Rackham",
        "author_office": "At vero eos",
        "show_category": true,
        "show_author_name": true,
        "show_divider": true,
      };
    } else if (type === "table-1") {
      obj = {
        "id": uuidv1(),
        "type": "table-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "headers_background": "#00643e",
        "headers_color": "#FFFFFF",
        "table": createObjectTable(),
      };
    } else if (type === "text-1") {
      obj = {
        "id": uuidv1(),
        "type": "text-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "text": '<p><span style="font-size: 18px;' + `color: #313537;` + 'line-height: 26px;">Lorem ipsum <b>dolor sit amet</b>, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin, sagittis nulla eget, blandit arcu. Etiam fermentum nunc nisl, in porttitor dui viverra quis. Etiam fringilla dolor id lobortis congue. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec faucibus eu felis id suscipit.</span></p>'
      };
    } else if (type === "text-2") {
      obj = {
        "id": uuidv1(),
        "type": "text-2",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "text": '<h1><span style="font-size: 30px; ' + `color: #313537;` + '">Lorem ipsum</span></h1><p><span style="font-size: 18px; ' + `color: #313537;` + ' line-height: 26px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin, sagittis nulla eget, blandit arcu. Etiam fermentum nunc nisl, in porttitor dui viverra quis. Etiam fringilla dolor id lobortis congue. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec faucibus eu felis id suscipit.</span></p>'
      };
    }
    else if (type === "interactive-video") {
      obj = {
        "id": uuidv1(),
        "type": "interactive-video",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "url": "https://www.youtube.com/watch?v=JgZrJATtN-w",
        "pausing_minute": 0,
        "pausing_second": 5,
        "questions": [
          {
            "id": uuidv1(),
            "title": "Lorem ipsum set dollor?",
            "seconds": 5,
            "minutes": 0,
            "hours": 0,
            "anchor_time": {
              "correct": 75,
              "error": 5
            },
            "choices": [
              {
                "id": uuidv1(),
                "correct": true,
                "text": 'Sed ut perspiciatis unde omnis iste natus',
                "skills": [
                  {
                    id: uuidv1(),
                    value: '',
                    reference: null,
                  }
                ]
              },
              {
                "id": uuidv1(),
                "correct": false,
                "text": 'Sed ut perspiciatis unde omnis iste natus',
                "value": 10,
                "skills": [
                  {
                    id: uuidv1(),
                    value: '',
                    reference: null,
                  }
                ]
              },
            ],
          }
        ]
      }
    }
    else if (type === "text-3") {
      obj = {
        "id": uuidv1(),
        "type": "text-3",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "text": '<h2><span style="' + `color: #313537;` + ' font-size: 20px;">Sed ut perspiciatis</span></h2><p><span style="' + `color: #313537;` + ' font-size: 18px; line-height: 26px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin, sagittis nulla eget, blandit arcu. Etiam fermentum nunc nisl, in porttitor dui viverra quis. Etiam fringilla dolor id lobortis congue. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec faucibus eu felis id suscipit.</span></p>'
      };
    } else if (type === "text-4") {
      obj = {
        "id": uuidv1(),
        "type": "text-4",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "text": '<h1><span style=" ' + `color: #313537;` + ' font-size: 30px;">Lorem ipsum</span></h1>'
      };
    } else if (type === "text-5") {
      obj = {
        "id": uuidv1(),
        "type": "text-5",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "text": '<h2><span style=" ' + `color: #313537;` + ' font-size: 20px;">Sed ut perspiciatis</span></h2>'
      };
    } else if (type === "text-two-column") {
      obj = {
        "id": uuidv1(),
        "type": "text-two-column",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "items": [
          '<p><span style=" ' + `color: #313537;` + ' font-size: 18px; line-height: 26px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin, sagittis nulla eget, blandit arcu. Etiam fermentum nunc nisl, in porttitor dui viverra quis. Etiam fringilla dolor id lobortis congue. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec faucibus eu felis id suscipit.</span></p>',
          '<p><span style=" ' + `color: #313537;` + ' font-size: 18px; line-height: 26px;">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain.</span></p>'
        ]
      };
    } else if (type === "list-1" || type === "list-2" || type === "list-3") {
      obj = {
        "id": uuidv1(),
        "type": type,
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#297C43",
        "secondary_color": "#FFFFFF",
        "items": [
          {
            "id": uuidv1(),
            "text": '<p><span style=" ' + `color: #313537;` + ' font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula.</span></p>',
            "image": null,
            "video": null
          },
          {
            "id": uuidv1(),
            "text": '<p><span style=" ' + `color: #313537;` + ' font-size: 18px;">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi.</span></p>',
            "image": null,
            "video": null
          },
          {
            "id": uuidv1(),
            "text": '<p><span style=" ' + `color: #313537;` + ' font-size: 18px;">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint.</span></p>',
            "image": null,
            "video": null
          }
        ]
      };
    } else if (type === "text-6") {
      obj = {
        "id": uuidv1(),
        "type": "text-6",
        "content_title": null,
        "background_color": "#FFFFFF",
        "left": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        "right": "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo."
      };
    } else if (type === "image-1") {
      obj = {
        "id": uuidv1(),
        "type": "image-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "width": null,
        "background_color": "#FFFFFF",
        "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
        "caption": null
      };
    } else if (type === "image-2") {
      obj = {
        "id": uuidv1(),
        "type": "image-2",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-2/image-2.jpg",
        "caption": null
      };
    } else if (type === "image-3") {
      obj = {
        "id": uuidv1(),
        "type": "image-3",
        "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-3/image-3.jpg",
        "text": "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system.",
        "caption": null
      };
    } else if (type === "image-4") {
      obj = {
        "id": uuidv1(),
        "type": "image-4",
        "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-4/image-4.jpg",
        "text": "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system."
      };
    } else if (type === "images-gallery") {
      obj = {
        "id": uuidv1(),
        "type": "images-gallery",
        "images": [
          {
            src: "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
            caption: "",
            id: uuidv1()
          },
          {
            src: "https://pocs.digitalpages.com.br/rdpcomposer/media/image-2/image-2.jpg",
            caption: "",
            id: uuidv1()
          },
        ],
        "text": "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system."
      }
    } else if (type === "image-and-text") {
      obj = {
        "id": uuidv1(),
        "type": "image-and-text",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "image_width": "50%",
        "image_position": "left",
        "image_border_radius": 0,
        "background_image": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png",
        "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-2/image-2.jpg",
        "text": '<p><span style="font-size: 18px;">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system.</span></p>',
        "subtitle": null,
      };
    } else if (type === "image-with-text") {
      obj = {
        "id": uuidv1(),
        "type": "image-with-text",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "opacity": "50%",
        "opacity_color": "#000000",
        "divider_color": "#FFFFFF",
        "background_image": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png",
        "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
        "text": '<p><span style="color: #FFFFFF; font-size: 30px;">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account.</span></p>',
      };
    } else if (type === "audio-1") {
      obj = {
        "id": uuidv1(),
        "type": "audio-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "audio": "https://pocs.digitalpages.com.br/rdpcomposer/media/audio-1/audio-1.mp3"
      };
    } else if (type === "video-1") {
      obj = {
        "id": uuidv1(),
        "type": "video-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "video": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-1/video-1.mp4"
      };
    } else if (type === "video-interactive-1") {
      var layerOneUid = uuidv1();
      var layerTwoUid = uuidv1();
      var layerThreeUid = uuidv1();
      var layerFourUid = uuidv1();
      var layerFiveUid = uuidv1();
      obj = {
        "id": uuidv1(),
        "type": "video-interactive-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "layers": [
          {
            "id": layerOneUid,
            "layer_type": "video",
            "layer_asset": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-interactive-1/video-1.mp4",
            "interactions": [
              {
                "id": uuidv1(),
                "type": "hotspot",
                "width": 370,
                "height": 860,
                "position_x": 275,
                "position_y": 220,
                "breakpoint": 93,
                "target": {
                  "layer": layerTwoUid,
                  "time": 0,
                  "autoplay": true
                }
              },
              {
                "id": uuidv1(),
                "type": "hotspot",
                "width": 590,
                "height": 860,
                "position_x": 1035,
                "position_y": 220,
                "breakpoint": 93,
                "target": {
                  "layer": layerThreeUid,
                  "time": 0,
                  "autoplay": true
                }
              }
            ]
          },
          {
            "id": layerTwoUid,
            "layer_type": "video",
            "layer_asset": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-interactive-1/video-2.mp4",
            "interactions": [{
              "id": uuidv1(),
              "type": "automatic",
              "width": null,
              "height": null,
              "position_x": null,
              "position_y": null,
              "breakpoint": 11,
              "target": {
                "layer": layerOneUid,
                "time": 76,
                "autoplay": true
              }
            }]
          },
          {
            "id": layerThreeUid,
            "layer_type": "video",
            "layer_asset": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-interactive-1/video-3.mp4",
            "interactions": [{
              "id": uuidv1(),
              "type": "hotspot",
              "width": 815,
              "height": 220,
              "position_x": 540,
              "position_y": 340,
              "breakpoint": 160,
              "target": {
                "layer": layerFiveUid,
                "time": 0,
                "autoplay": true
              }
            },
            {
              "id": uuidv1(),
              "type": "hotspot",
              "width": 815,
              "height": 220,
              "position_x": 540,
              "position_y": 655,
              "breakpoint": 160,
              "target": {
                "layer": layerFourUid,
                "time": 0,
                "autoplay": true
              }
            }]
          },
          {
            "id": layerFourUid,
            "layer_type": "video",
            "layer_asset": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-interactive-1/video-4.mp4",
            "interactions": [{
              "id": uuidv1(),
              "type": "hotspot",
              "width": 815,
              "height": 220,
              "position_x": 540,
              "position_y": 340,
              "breakpoint": 19,
              "target": {
                "layer": layerFiveUid,
                "time": 0,
                "autoplay": true
              }
            },
            {
              "id": uuidv1(),
              "type": "hotspot",
              "width": 815,
              "height": 220,
              "position_x": 540,
              "position_y": 655,
              "breakpoint": 19,
              "target": {
                "layer": "current",
                "time": 0,
                "autoplay": true
              }
            }]
          },
          {
            "id": layerFiveUid,
            "layer_type": "video",
            "layer_asset": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-interactive-1/video-5.mp4",
            "interactions": []
          }
        ]
      };
    } else if (type === "iframe") {
      obj = {
        "id": uuidv1(),
        "type": "iframe",
        "content_title": null,
        "width": 800,
        "height": 560,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "url": "https://player.vimeo.com/video/411911652"
      };
    } else if (type === "accordion") {
      obj = {
        "id": uuidv1(),
        "type": "accordion",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "border_color": "#ff9900",
        "behavior": "keep-open",
        "items": [
          {
            "id": uuidv1(),
            "title": "Lorem ipsum",
            "text": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin, sagittis nulla eget, blandit arcu. Etiam fermentum nunc nisl, in porttitor dui viverra quis. Etiam fringilla dolor id lobortis congue. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec faucibus eu felis id suscipit.</span></p>',
            "image": null,
            "video": null
          },
          {
            "id": uuidv1(),
            "title": "Sed ut",
            "text": '<p><span style="font-size: 18px;">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?</span></p>',
            "image": null,
            "video": null
          },
          {
            "id": uuidv1(),
            "title": "At vero",
            "text": '<p><span style="font-size: 18px;">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.</span></p>',
            "image": null,
            "video": null
          }
        ]
      };
    } else if (type === "tabs") {
      obj = {
        "id": uuidv1(),
        "type": "tabs",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "active_color": "#00643e",
        "items": [
          {
            "id": uuidv1(),
            "title": "Lorem ipsum",
            "text": '<p><span style="font-size: 18px;">Lorem ipsum </span><strong style="font-size: 18px;">dolor sit amet</strong><span style="font-size: 18px;">, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin, sagittis nulla eget, blandit arcu. Etiam fermentum nunc nisl, in porttitor dui viverra quis. Etiam fringilla dolor id lobortis congue. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec faucibus eu felis id suscipit.</span></p>',
            "image": null,
            "video": null
          },
          {
            "id": uuidv1(),
            "title": "Sed ut",
            "text": '<p><span style="font-size: 18px;">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?</span></p>',
            "image": null,
            "video": null
          },
          {
            "id": uuidv1(),
            "title": "At vero",
            "text": '<p><span style="font-size: 18px;">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.</span></p>',
            "image": null,
            "video": null
          }
        ]
      };
    } else if (type === "flashcards-1") {
      obj = {
        "id": uuidv1(),
        "type": "flashcards-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "card_height": 240,
        "card_width": 240,
        "background_color": "#FFFFFF",
        "border_color": "#00643e",
        "items": [
          {
            "id": uuidv1(),
            "front_card": {
              "text": "Lorem Ipsum",
              "centered_image": null,
              "fullscreen_image": null
            },
            "back_card": {
              "text": "Excepteur sint",
              "centered_image": null,
              "fullscreen_image": null
            }
          },
          {
            "id": uuidv1(),
            "front_card": {
              "text": "Sed ut perspiciatis",
              "centered_image": null,
              "fullscreen_image": null
            },
            "back_card": {
              "text": "Quis autem",
              "centered_image": null,
              "fullscreen_image": null
            }
          },
          {
            "id": uuidv1(),
            "front_card": {
              "text": "At vero eos",
              "centered_image": null,
              "fullscreen_image": null
            },
            "back_card": {
              "text": "Itaque earum",
              "centered_image": null,
              "fullscreen_image": null
            }
          }
        ]
      };
    } else if (type === "flashcards-2") {
      obj = {
        "id": uuidv1(),
        "type": "flashcards-2",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "card_height": 360,
        "card_width": 360,
        "background_color": "#FFFFFF",
        "border_color": "#00643e",
        "items": [
          {
            "id": uuidv1(),
            "front_card": {
              "text": "Lorem Ipsum",
              "centered_image": null,
              "fullscreen_image": null
            },
            "back_card": {
              "text": "Excepteur sint",
              "centered_image": null,
              "fullscreen_image": null
            }
          },
          {
            "id": uuidv1(),
            "front_card": {
              "text": "Sed ut perspiciatis",
              "centered_image": null,
              "fullscreen_image": null
            },
            "back_card": {
              "text": "Quis autem",
              "centered_image": null,
              "fullscreen_image": null
            }
          },
          {
            "id": uuidv1(),
            "front_card": {
              "text": "At vero eos",
              "centered_image": null,
              "fullscreen_image": null
            },
            "back_card": {
              "text": "Itaque earum",
              "centered_image": null,
              "fullscreen_image": null
            }
          }
        ]
      };
    } else if (type === "quiz-1") {
      obj = {
        "id": uuidv1(),
        "type": "quiz-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#212b36",
        "remake": "enable",
        "max_attempts": 1,
        "utilization": {
          "enabled": false,
          "percentage": null
        },
        "feedback": {
          "type": "default", //correct_incorrect e default
        },
        "questions": [{
          "id": uuidv1(),
          "question": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_correct": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_incorrect": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_correct_answer": false,
          "no_feedback": false,
          "choices": [
            {
              "id": uuidv1(),
              "correct": true,
              "text": '<p><span style="font-size: 15px;">Sed ut perspiciatis unde omnis iste natus</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Sit voluptatem accusantium doloremque laudantium</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Nemo enim ipsam voluptatem quia voluptas sit</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Ut enim ad minima veniam, quis nostrum</span></p>'
            }
          ]
        }],
      };
    } else if (type === "quiz-2") {
      obj = {
        "id": uuidv1(),
        "type": "quiz-2",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#212b36",
        "remake": "enable",
        "max_attempts": 1,
        "utilization": {
          "enabled": false,
          "percentage": null
        },
        "feedback": {
          "type": "default", //correct_incorrect e default
        },
        "questions": [{
          "id": uuidv1(),
          "question": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_correct": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_incorrect": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_correct_answer": false,
          "no_feedback": false,
          "choices": [
            {
              "id": uuidv1(),
              "correct": true,
              "text": '<p><span style="font-size: 15px;">Sed ut perspiciatis unde omnis iste natus</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": true,
              "text": '<p><span style="font-size: 15px;">Sit voluptatem accusantium doloremque laudantium</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Nemo enim ipsam voluptatem quia voluptas sit</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Ut enim ad minima veniam, quis nostrum</span></p>'
            }
          ]
        }],
      };
    } else if (type === "quiz-3") {
      obj = {
        "id": uuidv1(),
        "type": "quiz-3",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#212b36",
        "remake": "enable",
        "max_attempts": 1,
        "utilization": {
          "enabled": false,
          "percentage": null
        },
        "feedback": {
          "type": "default", //correct_incorrect e default
        },
        "questions": [{
          "id": uuidv1(),
          "question": '<p><span style="font-size: 18px;">____ ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_correct": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_incorrect": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_correct_answer": false,
          "no_feedback": false,
          "choices": [
            {
              "id": uuidv1(),
              "text": 'Lorem'
            }
          ]
        }],
      };
    } else if (type === "quiz-4") {
      obj = {
        "id": uuidv1(),
        "type": "quiz-4",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#212b36",
        "remake": "enable",
        "max_attempts": 1,
        "utilization": {
          "enabled": false,
          "percentage": null
        },
        "feedback": {
          "type": "default", //correct_incorrect e default
        },
        "questions": [{
          "id": uuidv1(),
          "question": '<p><span style="font-size: 18px;">____ ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_correct": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_incorrect": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_correct_answer": false,
          "no_feedback": false,
          "choices": [
            {
              "id": uuidv1(),
              "title": '1',
              "correct": true,
              "matchTitle": '1'
            },
            {
              "id": uuidv1(),
              "title": '2',
              "correct": true,
              "matchTitle": '2'
            },
            {
              "id": uuidv1(),
              "title": '3',
              "correct": true,
              "matchTitle": '3'
            }
          ]
        }],
      };
    } else if (type === "quiz-5") {
      obj = {
        "id": uuidv1(),
        "type": "quiz-5",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#212b36",
        "remake": "enable",
        "max_attempts": 1,
        "utilization": {
          "enabled": false,
          "percentage": null
        },
        "grade_type": "numeral",
        "grade_numeral": {
          "min": 0,
          "max": 100,
          "steps": 10
        },
        "feedback": {
          "type": "default", //correct_incorrect e default
        },
        "questions": [{
          "id": uuidv1(),
          "question": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "answer": "",
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_correct": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_incorrect": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_correct_answer": false,
          "no_feedback": false,
        }],
      };
    } else if (type === "quiz-6") {
      obj = {
        "id": uuidv1(),
        "type": "quiz-6",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#212b36",
        "remake": "enable",
        "max_attempts": 1,
        "utilization": {
          "enabled": false,
          "percentage": null
        },
        "grade_type": "numeral",
        "grade_numeral": {
          "min": 0,
          "max": 100,
          "steps": 10
        },
        "feedback": {
          "type": "default", //correct_incorrect e default
        },
        "questions": [
          {
          "id": uuidv1(),
          "type": "quiz-1",
          "question": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_correct": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_incorrect": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_correct_answer": false,
          "no_feedback": false,
          "choices": [
            {
              "id": uuidv1(),
              "correct": true,
              "text": '<p><span style="font-size: 15px;">Sed ut perspiciatis unde omnis iste natus</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Sit voluptatem accusantium doloremque laudantium</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Nemo enim ipsam voluptatem quia voluptas sit</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Ut enim ad minima veniam, quis nostrum</span></p>'
            }
          ]
        },
          {
          "id": uuidv1(),
          "type": "quiz-2",
          "question": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_correct": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "feedback_incorrect": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_correct_answer": false,
          "no_feedback": false,
          "choices": [
            {
              "id": uuidv1(),
              "correct": true,
              "text": '<p><span style="font-size: 15px;">Sed ut perspiciatis unde omnis iste natus</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": true,
              "text": '<p><span style="font-size: 15px;">Sit voluptatem accusantium doloremque laudantium</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Nemo enim ipsam voluptatem quia voluptas sit</span></p>'
            },
            {
              "id": uuidv1(),
              "correct": false,
              "text": '<p><span style="font-size: 15px;">Ut enim ad minima veniam, quis nostrum</span></p>'
            }
          ]
        },
          {
            "id": uuidv1(),
            "type": "quiz-3",
            "question": '<p><span style="font-size: 18px;">____ ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
            "image": null,
            "video": null,
            "answered": false,
            "feedback_default": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "feedback_correct": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "feedback_incorrect": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "no_correct_answer": false,
            "no_feedback": false,
            "choices": [
              {
                "id": uuidv1(),
                "text": 'lorem'
              },
            ]
          },
          {
            "id": uuidv1(),
            "type": "quiz-5",
            "question": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?</span></p>',
            "image": null,
            "video": null,
            "answered": false,
            "answer": "",
            "feedback_default": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "feedback_correct": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "feedback_incorrect": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "no_correct_answer": false,
            "no_feedback": false,
          }
        ],
      };
    } else if (type === "quiz-7") {
      obj = {
        "id": uuidv1(),
        "type": "quiz-7",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#212b36",
        "remake": "enable",
        "max_attempts": 1,
        "utilization": {
          "enabled": false,
          "percentage": null
        },
        "feedback": {
          "type": "default", //correct_incorrect e default
        },
        "questions": [{
          "id": uuidv1(),
          "question": '<p><span style="font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?</span></p>',
          "image": null,
          "video": null,
          "answered": false,
          "feedback_default": {
            "text": null,
            "image": null,
            "video": null,
            "media_max_width": null
          },
          "no_feedback": false,
          "choices": [
            {
              "id": uuidv1(),
              "text": '1'
            },
            {
              "id": uuidv1(),
              "text": '2'
            },
            {
              "id": uuidv1(),
              "text": '3'
            },
            {
              "id": uuidv1(),
              "text": '4'
            },
            {
              "id": uuidv1(),
              "text": '5'
            },
            {
              "id": uuidv1(),
              "text": '6'
            },
            {
              "id": uuidv1(),
              "text": '7'
            },
            {
              "id": uuidv1(),
              "text": '8'
            },
            {
              "id": uuidv1(),
              "text": '9'
            },
            {
              "id": uuidv1(),
              "text": '10'
            }
          ]
        }],
      };
    } else if (type === "forum-1") {
      obj = {
        "id": uuidv1(),
        "type": "forum-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "confirm_button_text_color": "#FFFFFF",
        "confirm_button_background_color": "#00643e",
        "cancel_button_text_color": "#FFFFFF",
        "cancel_button_background_color": "#8f8f8f",
        "topic_button_color": "#00643e",
        "primary_topic_background_color": "#e1f1eb",
        "primary_topic_author_color": "#A8A8A8",
        "primary_topic_text_color": "#727272",
        "secondary_topic_background_color": "#f1f1f1",
        "secondary_topic_author_color": "#A8A8A8",
        "secondary_topic_text_color": "#727272",
        "grade_type": "numeral",
        "grade_numeral": {
          "min": 0,
          "max": 100,
          "steps": 10
        },
        "enable_new_topics": ["reviewer", "reviewadmin"],
      }
    } else if (type === "multimedia-2") {
      obj = {
        "id": uuidv1(),
        "type": "multimedia-2",
        "url": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-1/video-1.mp4"
      };
    } else if (type === "gallery-2") {
      obj = {
        "id": uuidv1(),
        "type": "gallery-2",
        "first_image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
        "second_image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-2/image-2.jpg"
      }
    } else if (type === "virtual-index-1") {
      obj = {
        "id": uuidv1(),
        "type": "virtual-index-1",
        "title": "Título do índice",
        "content_title": null
      }
    } else if (type === "tex-1") {
      obj = {
        "id": uuidv1(),
        "type": "tex-1",
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "formula_color": "#000000",
        "formula_font_size": "20px"
      }
    } else if (type === "divider-1") {
      obj = {
        "id": uuidv1(),
        "type": "divider-1",
        "padding_top": 35,
        "padding_bottom": 35,
        "height": 1,
        "background_color": "#FFFFFF",
        "divider_color": "#e6e6e6"
      }
    } else if (type === "divider-4") {
      obj = {
        "id": uuidv1(),
        "type": "divider-4",
        "padding_top": 35,
        "padding_bottom": 35,
        "height": 50,
        "background_color": "#FFFFFF",
        "divider_color": "#e6e6e6"
      }
    } else if (type === "divider-numbered") {
      obj = {
        "id": uuidv1(),
        "type": "divider-numbered",
        "padding_top": 35,
        "padding_bottom": 35,
        "height": 1,
        "background_color": "#FFFFFF",
        "divider_primary_color": "#297C43",
        "divider_secondary_color": "#FFFFFF"
      }
    } else if (type === "hotspots-1") {
      obj = {
        "id": uuidv1(),
        "type": "hotspots-1",
        "padding_top": 35,
        "padding_bottom": 35,
        "width": null,
        "background_color": "#FFFFFF",
        "spot_color": "#00643e",
        "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
        "image_alt": "",
        "spots": [
          {
            "id": uuidv1(),
            "x": "50",
            "y": "50",
            "icon": "01",
            "title": "Lorem ipsum dolor sit amet",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            "hasMedia": false,
            "isActive": false,
            "image": null,
            "audio": null,
          }
        ]
      };
    } else if (type === "statement-1") {
      obj = {
        "id": uuidv1(),
        "type": "statement-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "border_color": "#eaeaeb",
        "text": '<p class="ql-align-center"><span style=" ' + `color: #313537;` + ' font-size: 18px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin, sagittis nulla eget, blandit arcu.</span></p>',
        "font_family": "Grueber"
      };
    } else if (type === "statement-2") {
      obj = {
        "id": uuidv1(),
        "type": "statement-2",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "border_color": "#d5d5d5",
        "text": '<p class="ql-align-center"><span style=" ' + `color: #313537;` + ' font-size: 26px;' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin.</span></p>',
        "font_family": "Helvetica Neue"
      };
    } else if (type === "statement-3") {
      obj = {
        "id": uuidv1(),
        "type": "statement-3",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "border_color": "#d5d5d5",
        "text": '<p><span style="font-size: 40px; ' + ` color: #313537;"` + '><b>Lorem ipsum dolor</b> sit amet, consectetur adipiscing elit. Curabitur <b>tempor massa</b> ut luctus dictum. <b>Suspendisse</b> consectetur ex cursus, <b>tincidunt orci sit</b> amet, cursus ligula.</span></p>',
        "font_family": "Helvetica Neue"
      };
    } else if (type === "statement-4") {
      obj = {
        "id": uuidv1(),
        "type": "statement-4",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "border_color": "#d5d5d5",
        "text": '<p><span style="font-size: 30px; ' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin.</span></p>',
        "font_family": "Grueber"
      };
    } else if (type === "note-1") {
      obj = {
        "id": uuidv1(),
        "type": "note-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "icon": "info",
        "primary_color": "#ff631e",
        "secondary_color": "#ffefe9",
        "text": '<p class="ql-align-center"><span style="font-size: 14px; ' + ` color: ${getTheme() === 'dark' ? "#313537" : "#313537"};"` + '><b>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet, cursus ligula. Quisque feugiat malesuada ligula, vitae iaculis tellus bibendum vel. Aenean et quam sollicitudin.</b></span></p>'
      };
    } else if (type === "quote-1") {
      obj = {
        "id": uuidv1(),
        "type": "quote-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#e9eaeb",
        "background_color": "#FFFFFF",
        "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
        "text": '<p class="ql-align-center"><span style="font-size: 18px; ' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
        "author_name": '<p class="ql-align-center"><span style="font-size: 14px; ' + ` color: #313537;"` + '>H. Rackham</span></p>',
        "font_family": "Merriweather"
      };
    } else if (type === "quote-2") {
      obj = {
        "id": uuidv1(),
        "type": "quote-2",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#e9eaeb",
        "background_color": "#FFFFFF",
        "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
        "text": '<p class="ql-align-center"><span style="font-size: 30px; ' + ` color: #313537;"` + '">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
        "author_name": '<p class="ql-align-center"><span style="font-size: 14px; ' + ` color: #313537;"` + '">H. Rackham</span></p>',
        "font_family": "Helvetica Neue"
      };
    } else if (type === "quote-3") {
      obj = {
        "id": uuidv1(),
        "type": "quote-3",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#f8f8f8",
        "background_color": "#FFFFFF",
        "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
        "text": '<p><span style="font-size: 18px; ' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
        "author_name": '<p><span style="font-size: 14px; ' + ` color: #313537;"` + '>H. Rackham</span></p>',
        "font_family": "Merriweather"
      };
    } else if (type === "quote-4") {
      obj = {
        "id": uuidv1(),
        "type": "quote-4",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#FFFFFF",
        "background_color": "#f5f5f5",
        "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
        "text": '<p><span style="font-size: 18px; ' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
        "author_name": '<p><span style="font-size: 14px; ' + ` color: #313537;"` + '>H. Rackham</span></p>',
        "font_family": "Merriweather"
      };
    } else if (type === "quote-5") {
      obj = {
        "id": uuidv1(),
        "type": "quote-5",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#FFFFFF",
        "background_image": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png",
        "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
        "text": '<p><span style="font-size: 26px; color: #FFFFFF;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
        "author_name": "H. Rackham",
        "font_family": "Merriweather"
      };
    } else if (type === "quote-6") {
      obj = {
        "id": uuidv1(),
        "type": "quote-6",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#212b36",
        "background_color": "#FFFFFF",
        "items": [
          {
            "id": uuidv1(),
            "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
            "text": '<p class="ql-align-center"><span style="font-size: 18px; ' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
            "author_name": '<p class="ql-align-center"><span style="font-size: 14px; ' + ` color: #313537;"` + '>H. Rackham 1</span></p>',
          },
          {
            "id": uuidv1(),
            "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
            "text": '<p class="ql-align-center"><span style="font-size: 18px; ' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
            "author_name": '<p class="ql-align-center"><span style="font-size: 14px; ' + ` color: #313537;"` + '>H. Rackham 2</span></p>',
          },
          {
            "id": uuidv1(),
            "avatar": "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png",
            "text": '<p class="ql-align-center"><span style="font-size: 18px; ' + ` color: #313537;"` + '>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor massa ut luctus dictum. Suspendisse consectetur ex cursus, tincidunt orci sit amet.</span></p>',
            "author_name": '<p class="ql-align-center"><span style="font-size: 14px; ' + ` color: #313537;"` + '>H. Rackham 3</span></p>',
          }
        ],
        "font_family": "Merriweather"
      };
    } else if (type === "sorted-activity-1") {
      const pile1Id = uuidv1();
      const pile2Id = uuidv1();
      obj = {
        "id": uuidv1(),
        "type": "sorted-activity-1",
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#297C43",
        "background_color": "#FFFFFF",
        "pile_color": "#e1e1e1",
        "pile_text_color": "#000",
        "item_color": "#FFFFFF",
        "item_text_color": "#000",
        "items": [
          {
            "id": uuidv1(),
            "title": "Item 1",
            "pileId": pile1Id,
          },
          {
            "id": uuidv1(),
            "title": "Item 2",
            "pileId": pile2Id,
          }
        ],
        "piles": [
          {
            "id": pile1Id,
            "title": "Pile 1",
          },
          {
            "id": pile2Id,
            "title": "Pile 2",
          }
        ]
      };
    } else if (type === "timeline-1") {
      obj = {
        "id": uuidv1(),
        "type": "timeline-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": getTheme() === 'dark' ?  "#673ab7" : "#00643e",
        "items": [
          {
            "id": uuidv1(),
            "date": "Date 1",
            "title": "Lorem ipsum dolor sit amet",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed. Accusantium amet cum cumque deleniti doloribus earum eligendi, eum exercitationem harum hic illum ipsa itaque labore libero magni minus neque nesciunt nihil non odio quam repellendus tempore velit, veniam veritatis? Aspernatur aut beatae blanditiis corporis dolorem eius harum incidunt ipsa, itaque iure labore laboriosam laborum magni maiores molestiae natus omnis quae reiciendis reprehenderit sed similique sit tempora tenetur velit veniam! Aliquid autem debitis dolores ducimus eaque est facilis incidunt ipsa ipsum laboriosam modi non perspiciatis placeat, quaerat quas quis totam vel velit? Deleniti deserunt expedita laudantium molestias porro, quas veritatis? Architecto dolor, provident. A accusantium architecto consequatur illum itaque necessitatibus perspiciatis reprehenderit sapiente veritatis vero. Consequatur doloremque ducimus ex molestias non. Dolore, harum ipsa ipsam laudantium nostrum tenetur ut voluptates!",
          },
          {
            "id": uuidv1(),
            "date": "Date 2",
            "title": "Lorem ipsum dolor sit amet",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed. Accusantium amet cum cumque deleniti doloribus earum eligendi, eum exercitationem harum hic illum ipsa itaque labore libero magni minus neque nesciunt nihil non odio quam repellendus tempore velit, veniam veritatis? Aspernatur aut beatae blanditiis corporis dolorem eius harum incidunt ipsa, itaque iure labore laboriosam laborum magni maiores molestiae natus omnis quae reiciendis reprehenderit sed similique sit tempora tenetur velit veniam! Aliquid autem debitis dolores ducimus eaque est facilis incidunt ipsa ipsum laboriosam modi non perspiciatis placeat, quaerat quas quis totam vel velit? Deleniti deserunt expedita laudantium molestias porro, quas veritatis? Architecto dolor, provident. A accusantium architecto consequatur illum itaque necessitatibus perspiciatis reprehenderit sapiente veritatis vero. Consequatur doloremque ducimus ex molestias non. Dolore, harum ipsa ipsam laudantium nostrum tenetur ut voluptates!",
          }
        ],
        "font_family": "Merriweather"
      };
    } else if (type === "steps-1") {
      obj = {
        "id": uuidv1(),
        "type": "steps-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "card_height": 360,
        "card_width": 360,
        "background_color": "#FFFFFF",
        "primary_color": getTheme() === 'dark' ?  "#673ab7" : "#00643e",
        "items": [
          {
            "id": uuidv1(),
            "type": "intro",
            "title": "Intro",
            "isHidden": false,
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed. Accusantium amet cum cumque deleniti doloribus earum eligendi, eum exercitationem harum hic illum ipsa itaque labore libero magni minus neque nesciunt nihil non odio quam repellendus tempore velit, veniam veritatis? Aspernatur aut beatae blanditiis corporis dolorem eius harum incidunt ipsa, itaque iure labore laboriosam laborum magni maiores molestiae natus omnis quae reiciendis reprehenderit sed similique sit tempora tenetur velit veniam! Aliquid autem debitis dolores ducimus eaque est facilis incidunt ipsa ipsum laboriosam modi non perspiciatis placeat, quaerat quas quis totam vel velit? Deleniti deserunt expedita laudantium molestias porro, quas veritatis? Architecto dolor, provident. A accusantium architecto consequatur illum itaque necessitatibus perspiciatis reprehenderit sapiente veritatis vero. Consequatur doloremque ducimus ex molestias non. Dolore, harum ipsa ipsam laudantium nostrum tenetur ut voluptates!",
          },
          {
            "id": uuidv1(),
            "type": "step",
            "title": "Lorem ipsum dolor sit amet",
            "isHidden": false,
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed. Accusantium amet cum cumque deleniti doloribus earum eligendi, eum exercitationem harum hic illum ipsa itaque labore libero magni minus neque nesciunt nihil non odio quam repellendus tempore velit, veniam veritatis? Aspernatur aut beatae blanditiis corporis dolorem eius harum incidunt ipsa, itaque iure labore laboriosam laborum magni maiores molestiae natus omnis quae reiciendis reprehenderit sed similique sit tempora tenetur velit veniam! Aliquid autem debitis dolores ducimus eaque est facilis incidunt ipsa ipsum laboriosam modi non perspiciatis placeat, quaerat quas quis totam vel velit? Deleniti deserunt expedita laudantium molestias porro, quas veritatis? Architecto dolor, provident. A accusantium architecto consequatur illum itaque necessitatibus perspiciatis reprehenderit sapiente veritatis vero. Consequatur doloremque ducimus ex molestias non. Dolore, harum ipsa ipsam laudantium nostrum tenetur ut voluptates!",
          },
          {
            "id": uuidv1(),
            "type": "step",
            "title": "Lorem ipsum dolor sit amet",
            "isHidden": false,
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed. Accusantium amet cum cumque deleniti doloribus earum eligendi, eum exercitationem harum hic illum ipsa itaque labore libero magni minus neque nesciunt nihil non odio quam repellendus tempore velit, veniam veritatis? Aspernatur aut beatae blanditiis corporis dolorem eius harum incidunt ipsa, itaque iure labore laboriosam laborum magni maiores molestiae natus omnis quae reiciendis reprehenderit sed similique sit tempora tenetur velit veniam! Aliquid autem debitis dolores ducimus eaque est facilis incidunt ipsa ipsum laboriosam modi non perspiciatis placeat, quaerat quas quis totam vel velit? Deleniti deserunt expedita laudantium molestias porro, quas veritatis? Architecto dolor, provident. A accusantium architecto consequatur illum itaque necessitatibus perspiciatis reprehenderit sapiente veritatis vero. Consequatur doloremque ducimus ex molestias non. Dolore, harum ipsa ipsam laudantium nostrum tenetur ut voluptates!",
          },
          {
            "id": uuidv1(),
            "type": "summary",
            "title": "Summary",
            "isHidden": false,
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed. Accusantium amet cum cumque deleniti doloribus earum eligendi, eum exercitationem harum hic illum ipsa itaque labore libero magni minus neque nesciunt nihil non odio quam repellendus tempore velit, veniam veritatis? Aspernatur aut beatae blanditiis corporis dolorem eius harum incidunt ipsa, itaque iure labore laboriosam laborum magni maiores molestiae natus omnis quae reiciendis reprehenderit sed similique sit tempora tenetur velit veniam! Aliquid autem debitis dolores ducimus eaque est facilis incidunt ipsa ipsum laboriosam modi non perspiciatis placeat, quaerat quas quis totam vel velit? Deleniti deserunt expedita laudantium molestias porro, quas veritatis? Architecto dolor, provident. A accusantium architecto consequatur illum itaque necessitatibus perspiciatis reprehenderit sapiente veritatis vero. Consequatur doloremque ducimus ex molestias non. Dolore, harum ipsa ipsam laudantium nostrum tenetur ut voluptates!",
          },
        ]
      };
    } else if (type === "attachment-1") {
      obj = {
        "id": uuidv1(),
        "type": "attachment-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "primary_color": "#00643e",
        "items": [
          {
            "id": uuidv1(),
            "type": "attachment",
            "size": 546677,
            "filename": "image-1.jpg",
            "mime_type": "image/jpeg",
            "original_url": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
          },
        ],
        "font_family": "Merriweather"
      };
    } else if (type === "gallery-1") {
      obj = {
        "id": uuidv1(),
        "type": "gallery-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#212b36",
        "background_color": "#FFFFFF",
        "items": [
          {
            "id": uuidv1(),
            "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
          },
          {
            "id": uuidv1(),
            "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-2/image-2.jpg",
          },
          {
            "id": uuidv1(),
            "image": "https://pocs.digitalpages.com.br/rdpcomposer/media/image-1/image-1.jpg",
          }
        ],
        "font_family": "Merriweather"
      };
    } else if (type === "snippet-1") {
      obj = {
        "id": uuidv1(),
        "type": "snippet-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "snippet_background_color": "#e9eaeb",
        "items": [
          {
            "id": uuidv1(),
            "code": '&lt;!DOCTYPE html&gt;\n' +
              '&lt;html lang=&quot;en&quot;&gt;\n' +
              '\t&lt;head&gt;\n' +
              '\t\t&lt;meta charset=&quot;utf-8&quot;&gt;\n' +
              '\t\t&lt;title&gt;title&lt;/title&gt;\n' +
              '\t\t&lt;link rel=&quot;stylesheet&quot; href=&quot;style.css&quot;&gt;\n' +
              '\t\t&lt;script src=&quot;script.js&quot;&gt;&lt;/script&gt;\n' +
              '\t&lt;/head&gt;\n' +
              '\t&lt;body&gt;\n' +
              '\t\t&lt;!-- page content --&gt;\n' +
              '\t&lt;/body&gt;\n' +
              '&lt;/html&gt;',
            "caption": "",
          },
        ],
        "font_family": "Merriweather"
      };
    } else if (type === "button-1") {
      obj = {
        "id": uuidv1(),
        "type": "button-1",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#212b36",
        "background_color": "#FFFFFF",
        "items": [
          {
            "id": uuidv1(),
            "type": "link",
            "label": "Button 1",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed.",
            "destination": "",
          },
        ],
        "font_family": "Merriweather"
      };
    } else if (type === "button-2") {
      obj = {
        "id": uuidv1(),
        "type": "button-2",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "primary_color": "#212b36",
        "background_color": "#FFFFFF",
        "items": [
          {
            "id": uuidv1(),
            "type": "link",
            "label": "Button 1",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed.",
            "destination": "",
          },
          {
            "id": uuidv1(),
            "type": "email",
            "label": "Button 2",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At aut impedit inventore nihil reiciendis. Ad alias amet aspernatur dignissimos exercitationem reiciendis? Amet eos incidunt labore vel veniam? Explicabo, hic, sed.",
            "destination": "",
          },
        ],
        "font_family": "Merriweather"
      };
    } else if (type === "3d") {
      obj = {
        "id": uuidv1(),
        "type": "3d",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "file": "https://pocs.digitalpages.com.br/rdpcomposer/media/3d/3d.glb"
      };
    } else if (type === "math-formula") {
      obj = {
        "id": uuidv1(),
        "type": "math-formula",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "formula_color": "#000000",
        "formula_font_size": "20px",
        "formula": "E = mc^2",
        "display_mode": "block"
      };
    } else if (type === "charts-infographics") {
      obj = {
        "id": uuidv1(),
        "type": "charts-infographics",
        "content_title": null,
        "content_type": "chart",
        "chart_type": "bar",
        "chart_height": 400,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "show_fallback_table": true,
        "accessibility_description": "",
        "description": "",
        "chart_data": {
          "labels": ["Janeiro", "Fevereiro", "Março", "Abril"],
          "datasets": [{
            "label": "Vendas",
            "data": [12, 19, 3, 5],
            "backgroundColor": "rgba(45, 123, 69, 0.6)",
            "borderColor": "rgba(45, 123, 69, 0.8)",
            "borderWidth": 2
          }]
        },
        "chart_options": {
          "show_legend": true,
          "legend_position": "top",
          "show_tooltips": true,
          "show_x_axis": true,
          "show_y_axis": true,
          "x_axis_label": "",
          "y_axis_label": "",
          "chart_title": ""
        }
      };
    } else if (type === "matriz-didatica") {
      obj = {
        "id": uuidv1(),
        "type": "matriz-didatica",
        "content_title": null,
        "padding_top": 35,
        "padding_bottom": 35,
        "background_color": "#FFFFFF",
        "font_family": "Lato",
        "curso": "",
        "carga_horaria_total": "",
        "disciplina": "",
        "docente": "",
        "di_responsavel": "",
        "ementa": "",
        "objetivo_geral": "",
        "semanas": [],
        "videoaulas": []
      };
    }

    if (hasTempSlot) {
      structure[hasTempSlot] = obj;
    } else {
      structure.push(obj);
    };

    composition.structure = structure;
    this.setState({
      "composition": composition
    })

    DamService.setLocalContent(composition, this.props.match.params.content_uid);
  }

  onApplyTemplate(templateObj) {
    var composition = this.state.composition;
    var structure = composition.structure;
    var hasTempSlot = null;

    for (var i = 0; i < structure.length; i++) {
      if (structure[i].type === "temp-slot") {
        hasTempSlot = i;
      };
    };

    if (hasTempSlot !== null) {
      structure[hasTempSlot] = templateObj;
    } else {
      structure.push(templateObj);
    };

    composition.structure = structure;
    this.setState({
      "composition": composition
    })

    DamService.setLocalContent(composition, this.props.match.params.content_uid);
  }

  autoSize(element) {
    var target = element.target;
    setTimeout(function () {
      target.style.cssText = 'height:auto; padding:0';
      target.style.cssText = 'height:' + (target.scrollHeight + 8) + 'px';
    }, 0);
  }


  async onZipExport(needUpdateComposition) {
    var _this = this;

    const startExport = (uid) => {
      var contentUid = uid || this.props.match.params.content_uid;
      var accessToken = UserService.getUser().access_token;
      var title = this.generateSlug(this.state.composition.metadata.title);

      this.setState({
        "downloading": true,
        "opened_menu": false
      });

      DamService.downloadScormPackage(contentUid, accessToken, title).then(function (blob) {
        _this.downloadBlob(blob, title);
      });
    };

    if (needUpdateComposition) {
      await this.onSaveClick().then((response) => {
        const uid = response[0].uid;
        startExport(uid);
      })

      return;
    };
    startExport();
  }

  toggleIsTemplate(bool) {
    var composition = this.state.composition;

    if (bool) {
      this.setState({
        "render_composition_processes": true
      });
    } else {
      delete composition.workflows;
      delete composition.workflows_required_first;
      delete composition.workflows_required_last;
      composition.is_template = false;
      this.setState({
        "composition": composition
      });
    }
  }

  downloadBlob(blob, name) {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = blobUrl;
    link.download = name;

    document.body.appendChild(link);

    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    document.body.removeChild(link);

    this.setState({
      "downloading": false
    });
  }

  getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  downloadPublicStructure() {
    var _this = this;
    var composition = this.state.composition
    var structure = composition.structure;
    var accessToken = UserService.getUser().access_token;
    var assets = [];
    var publicAssets = [];
    composition.metadata.content_uid = this.props.match.params.content_uid;

    for (var i = 0; i < structure.length; i++) {
      var item = structure[i];
      var types = ["background_image", "avatar", "image", "video", "audio"];

      for (var j = 0; j < types.length; j++) {
        if (item[types[j]] !== undefined && _this.getParameterByName("uid", item[types[j]]) !== null) {
          assets.push(item[types[j]]);
        };
      };

      var items = item.items || item.questions;
      var itemsTypes = ["image", "video", "fullscreen_image", "centered_image"];

      if (items !== undefined) {

        for (var k = 0; k < items.length; k++) {
          for (var j = 0; j < itemsTypes.length; j++) {
            if (items[k][itemsTypes[j]] !== undefined && _this.getParameterByName("uid", items[k][itemsTypes[j]]) !== null) {
              assets.push(items[k][itemsTypes[j]])
            }
          }

          if (items[k].front_card !== undefined && _this.getParameterByName("uid", items[k].front_card.centered_image) !== null) {
            assets.push(items[k].front_card.centered_image)
          }

          if (items[k].front_card !== undefined && _this.getParameterByName("uid", items[k].front_card.fullscreen_image) !== null) {
            assets.push(items[k].front_card.fullscreen_image)
          }

          if (items[k].back_card !== undefined && _this.getParameterByName("uid", items[k].back_card.centered_image) !== null) {
            assets.push(items[k].back_card.centered_image)
          }

          if (items[k].back_card !== undefined && _this.getParameterByName("uid", items[k].back_card.fullscreen_image) !== null) {
            assets.push(items[k].back_card.fullscreen_image)
          }
        }
      }
    };

    if (assets.length === 0) {
      _this.downloadPublicZip(composition, structure, publicAssets);
      return;
    }

    for (var i = 0; i < assets.length; i++) {
      var uid = _this.getParameterByName("uid", assets[i]);
      DamService.getPubliContent(uid, accessToken, i + 1).then(function (data) {
        publicAssets.push(data);
        if (data.index === assets.length) {
          _this.downloadPublicZip(composition, structure, publicAssets);
        };
      });
    };
  }

  downloadPublicZip(composition, structure, publicAssets) {
    var _this = this;
    for (var i = 0; i < structure.length; i++) {
      var item = structure[i];
      var types = ["background_image", "avatar", "image", "video", "audio"];

      for (var j = 0; j < types.length; j++) {
        if (item[types[j]] !== undefined && _this.getParameterByName("uid", item[types[j]]) !== null) {
          for (var k = 0; k < publicAssets.length; k++) {
            if (publicAssets[k].original_uid === _this.getParameterByName("uid", item[types[j]])) {
              item[types[j]] = `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${publicAssets[k].share_uid}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}`;
            };
          };
        };
      };

      var items = item.items || item.questions;
      var itemsTypes = ["image", "video"];

      if (items !== undefined) {
        for (var j = 0; j < itemsTypes.length; j++) {
          for (var k = 0; k < items.length; k++) {
            if (items[k][itemsTypes[j]] !== undefined && _this.getParameterByName("uid", items[k][itemsTypes[j]]) !== null) {
              for (var l = 0; l < publicAssets.length; l++) {
                if (publicAssets[l].original_uid === _this.getParameterByName("uid", items[k][itemsTypes[j]])) {
                  items[k][itemsTypes[j]] = `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${publicAssets[l].share_uid}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}`;
                };
              };
            }

            for (var l = 0; l < publicAssets.length; l++) {
              if (items[k].front_card !== undefined && _this.getParameterByName("uid", items[k].front_card.centered_image) !== null) {
                if (publicAssets[l].original_uid === _this.getParameterByName("uid", items[k].front_card.centered_image)) {
                  items[k].front_card.centered_image = `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${publicAssets[l].share_uid}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}`;
                };
              }

              if (items[k].front_card !== undefined && _this.getParameterByName("uid", items[k].front_card.fullscreen_image) !== null) {
                if (publicAssets[l].original_uid === _this.getParameterByName("uid", items[k].front_card.fullscreen_image)) {
                  items[k].front_card.fullscreen_image = `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${publicAssets[l].share_uid}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}`;
                };
              }

              if (items[k].back_card !== undefined && _this.getParameterByName("uid", items[k].back_card.centered_image) !== null) {
                if (publicAssets[l].original_uid === _this.getParameterByName("uid", items[k].back_card.centered_image)) {
                  items[k].back_card.centered_image = `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${publicAssets[l].share_uid}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}`;
                };
              }

              if (items[k].back_card !== undefined && _this.getParameterByName("uid", items[k].back_card.fullscreen_image) !== null) {
                if (publicAssets[l].original_uid === _this.getParameterByName("uid", items[k].back_card.fullscreen_image)) {
                  items[k].back_card.fullscreen_image = `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${publicAssets[l].share_uid}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}`;
                };
              }
            };

          }
        }
      }
    };

    composition.structure = structure;

    JSZipUtils.getBinaryContent(composition.version + ".zip", function (err, data) {
      if (err) {
        throw err;
      };
      const manifest = xmlBuilder(composition);

      JSZip.loadAsync(data).then(function (zip) {
        zip.file("structure.js", 'window.structure = ' + JSON.stringify(composition));
        zip.file("imsmanifest.xml", manifest);
        zip.generateAsync({ type: "base64" }).then(function (base64) {
          var pack = "data:application/zip;base64," + base64;
          var downloadLink = document.createElement("a");
          downloadLink.setAttribute("href", pack);
          downloadLink.setAttribute("download", _this.generateSlug(composition.metadata.title) + ".zip");
          downloadLink.click();
          _this.setState({
            "opened_menu": false
          })
        });
      });
    });
  }

  setAssetsUidsAndPushAssets(composition) {
    var _this = this;
    var structure = composition.structure;
    composition.assets = [];

    structure = structure.filter(function(element) { return element.type != "temp-slot"; });

    for (var i = 0; i < structure.length; i++) {
      var element = structure[i];
      element.dam_assets = [];

      if (element.background_image !== null && element.background_image !== undefined) {
        if (_this.getParameterByName("uid", element.background_image) !== null) {
          element.dam_assets.push({
            "type": "image",
            "id": _this.getParameterByName("uid", element.background_image)
          });
        };
        composition.assets.push(element.background_image);
      };

      if (element.avatar !== null && element.avatar !== undefined) {
        if (_this.getParameterByName("uid", element.avatar) !== null) {
          element.dam_assets.push({
            "type": "image",
            "id": _this.getParameterByName("uid", element.avatar)
          });
        };
        composition.assets.push(element.avatar);
      };

      if (element.image !== null && element.image !== undefined) {
        if (_this.getParameterByName("uid", element.image) !== null) {
          element.dam_assets.push({
            "type": "image",
            "id": _this.getParameterByName("uid", element.image)
          });
        };
        composition.assets.push(element.image);
      };

      if (element.video !== null && element.video !== undefined) {
        if (_this.getParameterByName("uid", element.video) !== null) {
          element.dam_assets.push({
            "type": "video",
            "id": _this.getParameterByName("uid", element.video)
          });
        };
        composition.assets.push(element.video);
      };

      if (element.audio !== null && element.audio !== undefined) {
        if (_this.getParameterByName("uid", element.audio) !== null) {
          element.dam_assets.push({
            "type": "audio",
            "id": _this.getParameterByName("uid", element.audio)
          });
        };
        composition.assets.push(element.audio);
      };

      if (element.file !== null && element.file !== undefined) {
        if (_this.getParameterByName("uid", element.file) !== null) {
          element.dam_assets.push({
            "type": "file",
            "id": _this.getParameterByName("uid", element.file)
          });
        };
        composition.assets.push(element.file);
      };

      if (element.type === "accordion" || element.type === "tabs" || element.type === "quiz-1" || element.type === "quiz-2" || element.type === "quiz-3" || element.type === "quiz-4") {
        var items = (element.type === "quiz-1" || element.type === "quiz-2" || element.type === "quiz-3" || element.type === "quiz-4") ? element.questions : element.items;
        for (var j = 0; j < items.length; j++) {
          var item = items[j];

          if (item.image !== null && item.image !== undefined) {
            if (_this.getParameterByName("uid", item.image) !== null) {
              element.dam_assets.push({
                "type": "image",
                "id": _this.getParameterByName("uid", item.image)
              });
            };
            composition.assets.push(item.image);
          };

          if (item.video !== null && item.video !== undefined) {
            if (_this.getParameterByName("uid", item.video) !== null) {
              element.dam_assets.push({
                "type": "video",
                "id": _this.getParameterByName("uid", item.video)
              });
            };
            composition.assets.push(item.video);
          };

          if (element.type === "quiz-1" || element.type === "quiz-2" || element.type === "quiz-3" || element.type === "quiz-3") {
            item.answered = false;

            var choices = item.choices;
            for (var k = 0; k < choices.length; k++) {
              var choice = choices[k];
              if (choice.image && _this.getParameterByName("uid", choice.image) !== null) {
                element.dam_assets.push({
                  "type": "image",
                  "id": _this.getParameterByName("uid", choice.image)
                });
                composition.assets.push(choice.image);

              }

              if (choice.video && _this.getParameterByName("uid", choice.video) !== null) {
                element.dam_assets.push({
                  "type": "video",
                  "id": _this.getParameterByName("uid", choice.video)
                });
                composition.assets.push(choice.video);
              }
            }

            if (item.feedback_correct) {
              if (item.feedback_correct.image && _this.getParameterByName("uid", item.feedback_correct.image) !== null) {
                element.dam_assets.push({
                  "type": "image",
                  "id": _this.getParameterByName("uid", item.feedback_correct.image)
                });
                composition.assets.push(item.feedback_correct.image);
              }
              if (item.feedback_correct.video && _this.getParameterByName("uid", item.feedback_correct.video) !== null) {
                element.dam_assets.push({
                  "type": "video",
                  "id": _this.getParameterByName("uid", item.feedback_correct.video)
                });
                composition.assets.push(item.feedback_correct.video);
              }
            }
            if (item.feedback_default) {
              if (item.feedback_default.image && _this.getParameterByName("uid", item.feedback_default.image) !== null) {
                element.dam_assets.push({
                  "type": "image",
                  "id": _this.getParameterByName("uid", item.feedback_default.image)
                });
                composition.assets.push(item.feedback_default.image);
              }
              if (item.feedback_default.video && _this.getParameterByName("uid", item.feedback_default.video) !== null) {
                element.dam_assets.push({
                  "type": "video",
                  "id": _this.getParameterByName("uid", item.feedback_default.video)
                });
                composition.assets.push(item.feedback_default.video);
              }
            }
            if (item.feedback_incorrect) {
              if (item.feedback_incorrect.image && _this.getParameterByName("uid", item.feedback_incorrect.image) !== null) {
                element.dam_assets.push({
                  "type": "image",
                  "id": _this.getParameterByName("uid", item.feedback_incorrect.image)
                });
                composition.assets.push(item.feedback_incorrect.image);
              }
              if (item.feedback_incorrect.video && _this.getParameterByName("uid", item.feedback_incorrect.video) !== null) {
                element.dam_assets.push({
                  "type": "video",
                  "id": _this.getParameterByName("uid", item.feedback_incorrect.video)
                });
                composition.assets.push(item.feedback_incorrect.video);
              }
            }
          }
        };
      };

      if (element.type === 'table-1') {
        const items = [];
        const { rows, columns } = element.table.data;
        rows.forEach(row => {
          columns.forEach(col => {
            const cell = row.cells[col.id];

            if (cell && cell.type === 'image') {
              items.push(cell.value);
            };
          })
        });

        composition.assets.push(...items);
      };

      if (element.type === "images-gallery") {
        var items = element.images;

        for (var j = 0; j < items.length; j++) {
          var item = items[j];

          element.dam_assets.push({
            "type": "image",
            "id": _this.getParameterByName("uid", item.src)
          })
          composition.assets.push(item.src);
        }
      }

      if (element.type === "quote-6") {
        const items = element.items;

        for (let j = 0; j < items.length; j++) {
          const item = items[j];

          element.dam_assets.push({
            "type": "image",
            "id": _this.getParameterByName("uid", item.avatar)
          })
          composition.assets.push(item.avatar);
        }
      }

      if (element.type === "gallery-1") {
        const items = element.items;

        for (let j = 0; j < items.length; j++) {
          const item = items[j];

          element.dam_assets.push({
            "type": "image",
            "id": _this.getParameterByName("uid", item.image)
          })
          composition.assets.push(item.image);
        }
      }

      if (element.type === "flashcards-1" || element.type === "flashcards-2") {
        var items = element.items;
        for (var j = 0; j < items.length; j++) {
          var item = items[j];

          if (item.back_card.centered_image !== null) {
            element.dam_assets.push({
              "type": "image",
              "id": _this.getParameterByName("uid", item.back_card.centered_image)
            });
            composition.assets.push(item.back_card.centered_image);
          };

          if (item.back_card.fullscreen_image !== null) {
            element.dam_assets.push({
              "type": "image",
              "id": _this.getParameterByName("uid", item.back_card.fullscreen_image)
            });
            composition.assets.push(item.back_card.fullscreen_image);
          };

          if (item.front_card.centered_image !== null) {
            element.dam_assets.push({
              "type": "image",
              "id": _this.getParameterByName("uid", item.front_card.centered_image)
            });
            composition.assets.push(item.front_card.centered_image);
          };

          if (item.front_card.fullscreen_image !== null) {
            element.dam_assets.push({
              "type": "image",
              "id": _this.getParameterByName("uid", item.front_card.fullscreen_image)
            });
            composition.assets.push(item.front_card.fullscreen_image);
          };
        };
      };

      if (element.type === "hotspots-1") {
        const {spots = []} = element;

        for (let spotCounter = 0; spotCounter < spots.length; spotCounter++) {
          const spot = spots[spotCounter];
          const {image = null, audio = null} = spot;

          if (image !== null) {
            element.dam_assets.push({
              "type": "image",
              "id": _this.getParameterByName("uid", image)
            });
            composition.assets.push(image);
          }

          if (audio !== null) {
            element.dam_assets.push({
              "type": "audio",
              "id": _this.getParameterByName("uid", audio)
            });
            composition.assets.push(audio);
          }
        }
      }

      if (element.type === "attachment-1") {
        const {items = []} = element;

        for (let counter = 0; counter < items.length; counter++) {
          const item = items[counter];
          const {original_url} = item;

          if (original_url !== null) {
            element.dam_assets.push({
              "type": "file",
              "id": _this.getParameterByName("uid", original_url)
            });
            composition.assets.push(original_url);
          }
        }
      }

      if (element.type === "timeline-1") {
        const {items = []} = element;

        for (let index = 0; index < items.length; index++) {
          const item = items[index];
          const {image = null, audio = null} = item;

          if (image !== null) {
            element.dam_assets.push({
              "type": "image",
              "id": _this.getParameterByName("uid", image)
            });
            composition.assets.push(image);
          }

          if (audio !== null) {
            element.dam_assets.push({
              "type": "audio",
              "id": _this.getParameterByName("uid", audio)
            });
            composition.assets.push(audio);
          }
        }
      }

      if (element.type === "steps-1") {
        const {items = []} = element;

        for (let index = 0; index < items.length; index++) {
          const item = items[index];
          const {image = null, audio = null} = item;

          if (image !== null) {
            element.dam_assets.push({
              "type": "image",
              "id": _this.getParameterByName("uid", image)
            });
            composition.assets.push(image);
          }

          if (audio !== null) {
            element.dam_assets.push({
              "type": "audio",
              "id": _this.getParameterByName("uid", audio)
            });
            composition.assets.push(audio);
          }
        }
      }

      if (element.type === "video-interactive-1") {
        const {layers = []} = element;
        for (let index = 0; index < layers.length; index++) {
          const item = layers[index];
          const {layer_asset = null} = item;

          if (layer_asset !== null) {
            element.dam_assets.push({
              "type": "video",
              "id": _this.getParameterByName("uid", layer_asset)
            });
            composition.assets.push(layer_asset);
          }
        }
      }
    }

    composition.structure = structure;

    return composition;
  }

  generateSlug(str) {
    return str !== null ? str.replace(/\s+/g, '-').toLowerCase() : "Untitled";
  }

  onPreviewClick() {
    var _this = this;
    if (this.state.user_is_creator_viewer) _this.redirectToPreview();
    
    var mirrorComposition = this.state.mirror_composition;
    var composition = JSON.stringify(this.state.composition);
    if (mirrorComposition !== composition && this.props.match.params.content_uid !== undefined) {
      _this.setState({
        "redirect_to_preview": true
      }, function () {
        _this.onSaveClick();
      });
    } else {
      _this.redirectToPreview();
    };
  }

  onProcessesClick() {
    this.setState({
      "render_composition_processes": true
    })
  }

  onToggleMenu() {
    this.setState({
      "opened_menu": !this.state.opened_menu
    });
  }

  onToggleHelp() {
    this.setState({
      "opened_help": !this.state.opened_help
    });
  }

  setCurrentVersion() {
    var composition = this.state.composition;
    composition.version = "1.1";
    this.setState({
      "composition": composition
    });
    return composition;
  }

  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  }

  getCompositionFile() {
    var tempComposition = this.state.composition;
    var fileType = tempComposition.is_template ? "digitalpages/composer-template" : "digitalpages/composer";
    var fileExtension = tempComposition.is_template ? "composition.rdpcomposer-template" : "composition.rdpcomposer";
    var composition = this.setAssetsUidsAndPushAssets(tempComposition);
    composition = this.setCurrentVersion();

    var myBlob = new Blob([JSON.stringify(composition)], { type: fileType });
    return this.blobToFile(myBlob, fileExtension);
  }

  refreshIds() {
    var composition = JSON.parse(JSON.stringify(this.state.composition));

    var structure = composition.structure;
    for (var i = 0; i < structure.length; i++) {
      var obj = structure[i];
      obj.id = uuidv1();

      var images = obj.images;
      if (images) {
        for (var j = 0; j < images.length; j++) {
          images[j].id = uuidv1();
        }
      }

      var items = obj.items;
      if (items) {
        for (var j = 0; j < items.length; j++) {
          items[j].id = uuidv1();
        }
      }

      var questions = obj.questions;
      if (questions) {
        for (var j = 0; j < questions.length; j++) {
          questions[j].id = uuidv1();

          var choices = questions[j].choices;
          if (choices) {
            for (var k = 0; k < choices.length; k++) {
              choices[k].id = uuidv1();
            }
          }
        }
      }
    }

    composition.structure = structure;

    return composition;
  }

  correctConnector()
  {
    var connector = null;
    var project = JSON.parse(window.localStorage.getItem("rdp-composer-active-project"));
    if (project && project.connectors) connector = project.connectors.find(p=> p.internal_name == "Dam");
    if (!connector && project && project.connectors) connector = project.connectors[0];

    return connector;
  }

  onSaveClick(onlyEdit) {
    var _this = this;
    const { connectors, uid: projectUid } = JSON.parse(window.localStorage.getItem("rdp-composer-active-project"));
    // const composerConnector = getConnectorFromArray(connectors, "Composer_1", "ContentManager");
    // const composerConnector = connectors.find(item => item.type === "Composer_1");
    // var connectorUid = composerConnector.uid || null;

    // if (connectorUid === null) {
    //   const projectConnectorScope = connectors.find(connector => connector.scope === "Project");
    //   connectorUid = projectConnectorScope.uid || null;
    // }

    var connector = this.correctConnector();

    var url = `https://${RDP_CONFIG.domain}/storage/v1.0/upload/connector/uid/${connector.uid}?manual_project_uid=${projectUid}`;
    var method = "POST";
    var fd = new FormData();
    var files = this.getCompositionFile();
    var userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    var type = userData.type;
    var accessToken = userData.access_token;

    _this.setState({
      "opened_menu": false,
      "displayed_preloader": true
    });

    fd.append('file', files, "composition.rdpcomposer")

    if (this.props.match.params.content_uid !== undefined) {
      method = "PUT";
      url = `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${this.props.match.params.content_uid}&manual_project_uid=${projectUid}`;
    };

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        type: method,
        data: fd,
        contentType: false,
        processData: false,
        headers: {
          "Authorization": type + " " + accessToken,
          "Project-Key" : RDP_CONFIG.projectKey,
          "Api-Env" : RDP_CONFIG.apiEnv
        },
        success: function (response) {
          var newId = response[0].uid;

          _this.setState({
            "displayed_preloader": false,
            "mirror_composition": JSON.stringify(_this.state.composition)
          });
          if (_this.state.redirect_to_home === true) {
            if (onlyEdit) {
              _this.sendMessage({
                "origin": "composer",
                "new_composition_uid": newId,
                "action": "close"
              });
            } else {
              _this.redirectToHome()
            }
          } else if (_this.state.redirect_to_preview === true) {
            _this.redirectToPreview(newId)
          } else {
            var path = _this.state.is_embed > -1 ? "#/embed/composer/" : "#/composer/";
            var lastPath = onlyEdit ? "/onlyedit" : "";

            window.location.href = window.location.href.split("#/")[0] + path + newId + lastPath;

            _this.updateLocationWithID(newId);

            const lastVersion = _this.state.versions[_this.state.versions.length - 1];
            if (lastVersion) {
              _this.setState({
                versions: [..._this.state.versions, {
                  ...lastVersion,
                  content_uid: newId,
                  label: `Versão ${_this.state.versions.length + 1}`
                }]
              })
            }
          }
          resolve(response);
        },
        error: function (response) {
          _this.setState({
            "displayed_preloader": false
          });
          reject(response);
        }
      });
    });
  }

  updateLocationWithID(id) {
    const _this = this;
    const path = _this.state.is_embed ? "#/embed/composer/" : "#/composer/";
    const query = false === _this.state.is_embed ? `?file_uid=${new Url(window.location.href).getQueryParams().file_uid}` : "";
    window.location.href = window.location.href.split("#/")[0] + path + id + query;
  }

  onConfigurationClick() {
    this.setState({
      "opened_configurations": true,
      "opened_menu": false
    })
  }

  onVersionsHistoryClick() {
    const [first] = this.state.versions;
    const last = this.state.versions[this.state.versions.length - 1];

    this.setState({
      "render_versions_history": true,
      ...(first && last && {
        first_version: first.content_uid,
        second_version: last.content_uid
      })
    })
  }

  onConfigurationsClose() {
    this.setState({
      "opened_configurations": false
    })
  }

  renderElementEdit() {
    if (this.state.enabled_element_edit_props === true) {
      return <ElementEdit structure={this.state.composition.structure} labels={this.state.labels} content={this.state.element_edit_props} onChange={(element) => this.onElementChange(element)} onClose={() => this.onElementEditClose()} />;
    };
  }

  renderElementMessages() {
    if (this.state.enabled_element_message_object_uid !== null) {
      return <ElementMessages labels={this.state.labels} users={this.state.project_users} content_uid={this.props.match.params.content_uid} user_uid={UserService.getUserInfo().uid} object_uid={this.state.enabled_element_message_object_uid} onClose={() => this.onElementCloseMessages()}/>;
    };
  }

  onCompositionChange(composition) {
    this.setState({
      "composition": composition
    });
  }

  renderElementActivites() {
    if (this.state.render_activities) {
      return <ElementActivities
        composition={this.state.composition}
        onCompositionChange={(composition) => this.onCompositionChange(composition)}
        labels={this.state.labels}
        users={this.state.project_users}
        content_uid={this.props.match.params.content_uid}
        user_uid={UserService.getUserInfo().uid}
        object_id={this.state.current_object_id}
        onClose={() => this.onCloseActivities()}
      />
    }
  }

  renderConfigurations() {
    if (this.state.opened_configurations === true) {
      return <Configurations
        composition={this.state.composition}
        onClose={() => this.onConfigurationsClose()}
        onMetadataChange={(index, content) => this.onMetadataChange(index, content)}
        labels={this.state.labels}
      />;
    };
  }

  renderPreloader() {
    if (this.state.displayed_preloader === true) {
      return <div className="rdp-composer-composer-preloader"></div>;
    }
  }

  redirectToHome() {
    var path = this.state.is_embed ? "/embed/" : "/";
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  redirectToPreview(uid) {
    var path = this.state.is_embed ? "#/embed/preview/" : "#/preview/";
    var lastPath = this.props.match.path.search("onlyedit") > -1 ? "/onlyedit" : "";

    var contentUid = uid !== undefined ? uid : this.props.match.params.content_uid;
    window.location.href = window.location.href.split("#/")[0] + path + contentUid + lastPath;
  }

  sendMessage(obj) {
    window.parent.postMessage(obj, "*");
  }

  async onBackClick() {
    var _this = this;
    var onlyEdit = this.props.match.path.search("onlyedit") > -1;
    const mirrorComposition = this.state.mirror_composition;
    const composition = JSON.stringify(this.state.composition);
    const mirror = JSON.stringify(this.state.composition_backup);

    if(composition === mirror || this.state.user_is_creator_viewer) {
      _this.redirectToHome();
      return;
    }

    _this.setState({ displayed_preloader: true })

    const userUuid = UserService.getUUid();
    const compositionCpy = {...this.state.composition};
    {
      const userData = UserService.getUser();
      const type = userData.type;
      const accessToken = userData.access_token;

      const formatedUrl = window.location.href.replace('/?#', '');

      const fileUid = new URL(formatedUrl).searchParams.get('file_uid');
      // const fileUid = new Url(window.location.href).getQueryParams().file_uid;

      if (fileUid !== undefined) {
        const resp = await DamService.searchContent(`filter=(file_uid eq '${fileUid}')`, "", type, accessToken)

        if (resp && resp.results.length === 1) {
          const file = resp.results[0];
          const content = await DamService.getContent(file.document.content_uid, accessToken);

          const comp = JSON.parse(content);

          if ("metadata" in comp && "editor_uuid" in comp.metadata && comp.metadata.editor_uuid !== userUuid) {
            Swal.fire({
              title: this.state.labels.attention,
              text: this.state.labels.lock_loss_message,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#212b36',
              confirmButtonText: this.state.labels.yes,
              cancelButtonText: this.state.labels.no,
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                const comp = JSON.parse(composition);
                comp.metadata.editor_uuid = userUuid;

                this.setState({
                  "composition": comp
                }, () => {
                  this.onSaveClick().then(() => {
                    this.redirectToHome();
                  });
                });
              } else if (
                result.dismiss === Swal.DismissReason.cancel
              ) {
                this.redirectToHome();
              }
            });
            return;
          }
        }
      }
    }

    if ("metadata" in compositionCpy && "editor_uuid" in compositionCpy.metadata && compositionCpy.metadata.editor_uuid === userUuid) {
      delete compositionCpy.metadata.editor_uuid;
    }

    if (mirrorComposition !== composition && this.props.match.params.content_uid !== undefined) {
      _this.setState({
        "redirect_to_home": true,
        composition: compositionCpy
      }, function () {
        _this.onSaveClick(onlyEdit);
        // this.redirectToHome();
      });
    } else {
      if (onlyEdit) {
        _this.sendMessage({
          "origin": "composer",
          "new_composition_uid": this.props.match.params.content_uid,
          "action": "close"
        });
      } else {
        _this.redirectToHome();
      }
    };
    // window.location = window.location.origin + window.location.pathname + "#/";
  }

  renderDownloadingPackage() {
    if (this.state.downloading === true) {
      return <Popup
        message="Aguarde, o pacote SCORM está sendo gerado e em breve o download será inicializado."
        opacity={0.95}
        top={0}
        bottom={0}
        left={0}
        right={0}
      />
    };
  }

  renderGoogleFonts() {
    var fonts = this.state.google_fonts;
    if (this.state.google_fonts_render_modal === true && fonts !== null) {
      return <div className="rdp-composer-google-fonts">
        <ul>
          {fonts.map(function(font, index) {
            return <li key={index} >{font.family}</li>
          })}
        </ul>
      </div>
    }
  }

  handleSaveComposition(onlyEdit) {
    const userUuid = UserService.getUUid();
    const compositionCpy = {...this.state.composition};

    if ("metadata" in compositionCpy && "editor_uuid" in compositionCpy.metadata && compositionCpy.metadata.editor_uuid === userUuid) {
      delete compositionCpy.metadata.editor_uuid;
    }

    this.setState({
      composition: compositionCpy
    }, () => {
      this.onSaveClick(onlyEdit);
    });
  }
  
  onIa(element, index) {
    this.setState({
      "ia_element": element,
      "ia_index": index
    });

    if (element.type === "quiz-1") {
      this.setState({
        "ia_render_text_modal": false,
        "ia_render_quiz_modal": true
      });
    } else {
      this.setState({
        "ia_render_quiz_modal": false,
        "ia_render_text_modal": true
      });
    }
  }

  onCloseIa() {
    this.setState({
      "ia_render_text_modal": false,
      "ia_render_quiz_modal": false,
      "ia_render_create_text_modal": false,
      "ia_render_organize_script_modal": false,
      "ia_render_adapt_language_modal": false,
      "ia_render_generate_examples_modal": false,
      "ia_render_spellcheck_modal": false,
      "ia_spellcheck_errors": [],
      "ia_spellcheck_text": "",
      "ia_render_spellcheck_modal_preloader": false,
      "ia_element": null,
      "ia_index": null,
      "ia_render_text_modal_preloader": false,
      "ia_render_quiz_modal_preloader": false
    });
  }

  onOpenCreateText() {
    this.setState({
      "ia_render_create_text_modal": true
    });
  }

  onCloseCreateText() {
    this.setState({
      "ia_render_create_text_modal": false
    });
  }

  onCloseSpellcheck() {
    this.setState({
      "ia_render_spellcheck_modal": false,
      "ia_spellcheck_errors": [],
      "ia_spellcheck_text": ""
    });
  }

  onOpenAdaptLanguage() {
    this.setState({
      "ia_render_adapt_language_modal": true
    });
  }

  onCloseAdaptLanguage() {
    this.setState({
      "ia_render_adapt_language_modal": false,
      "ia_language_suggestions": []
    });
  }

  async onGenerateLanguageSuggestions(tone, complexity, target) {
    this.setState({ "ia_render_text_modal_preloader": true });
    const currentText = this.htmlToText(this.state.ia_element.text || "");
    
    const prompts = [
      `Reescreva o seguinte texto com tom ${tone} e nível ${complexity} para ${target}. IMPORTANTE: Responda APENAS com o texto reescrito, sem introduções, explicações ou comentários adicionais: ${currentText}`,
      `Adapte este texto para ser mais ${tone === 'formal' ? 'profissional' : tone === 'informal' ? 'descontraído' : 'equilibrado'} e ${complexity} para ${target}. IMPORTANTE: Responda APENAS com o texto adaptado, sem introduções, explicações ou comentários adicionais: ${currentText}`,
      `Reformule este conteúdo com linguagem ${tone} e complexidade ${complexity}, adequado para ${target}. IMPORTANTE: Responda APENAS com o conteúdo reformulado, sem introduções, explicações ou comentários adicionais: ${currentText}`
    ];
    
    try {
      const suggestions = [];
      for (let i = 0; i < prompts.length; i++) {
        const result = await this.callAiApi(prompts[i]);
        suggestions.push({
          title: `Sugestão ${i + 1} - ${tone.charAt(0).toUpperCase() + tone.slice(1)}`,
          text: result
        });
      }
      this.setState({ "ia_language_suggestions": suggestions });
    } catch (error) {
      console.error('Erro ao gerar sugestões:', error);
    }
    
    this.setState({ "ia_render_text_modal_preloader": false });
  }

  onApplySuggestion(suggestionText) {
    this.updateElementText(suggestionText);
    this.onCloseAdaptLanguage();
  }

  onOpenGenerateExamples() {
    this.setState({
      "ia_render_generate_examples_modal": true
    });
  }

  onCloseGenerateExamples() {
    this.setState({
      "ia_render_generate_examples_modal": false,
      "ia_examples_suggestions": []
    });
  }

  async onGenerateExamplesSuggestions(baseText) {
    this.setState({ "ia_render_text_modal_preloader": true });
    const currentText = this.htmlToText(this.state.ia_element.text || "");
    
    const prompts = [
      `Com base no seguinte conteúdo: "${currentText}" e usando como orientação: "${baseText}", gere um exemplo prático e contextualizado. IMPORTANTE: Responda APENAS com o exemplo, sem introduções ou explicações adicionais.`,
      `Crie uma atividade complementar baseada em: "${currentText}" seguindo a orientação: "${baseText}". IMPORTANTE: Responda APENAS com a atividade, sem introduções ou explicações adicionais.`,
      `Desenvolva um caso prático relacionado a: "${currentText}" considerando: "${baseText}". IMPORTANTE: Responda APENAS com o caso prático, sem introduções ou explicações adicionais.`
    ];
    
    try {
      const suggestions = [];
      for (let i = 0; i < prompts.length; i++) {
        const result = await this.callAiApi(prompts[i]);
        suggestions.push({
          title: `${i === 0 ? 'Exemplo Prático' : i === 1 ? 'Atividade Complementar' : 'Caso Prático'}`,
          text: result
        });
      }
      this.setState({ "ia_examples_suggestions": suggestions });
    } catch (error) {
      console.error('Erro ao gerar exemplos:', error);
    }
    
    this.setState({ "ia_render_text_modal_preloader": false });
  }

  onApplyExample(exampleText) {
    this.updateElementText(exampleText);
    this.onCloseGenerateExamples();
  }

  onOpenOrganizeScript() {
    this.setState({
      "ia_render_organize_script_modal": true
    });
  }

  onCloseOrganizeScript() {
    this.setState({
      "ia_render_organize_script_modal": false,
      "ia_script_suggestions": []
    });
  }

  async onGenerateScriptSuggestions() {
    this.setState({ "ia_render_text_modal_preloader": true });
    const currentText = this.htmlToText(this.state.ia_element.text || "");
    
    const prompts = [
      `Analise o seguinte conteúdo e sugira uma estrutura organizacional com tópicos e subtópicos em sequência lógica: "${currentText}". IMPORTANTE: Responda APENAS com a estrutura sugerida, sem introduções ou explicações adicionais.`,
      `Reorganize este conteúdo em seções temáticas com transições fluidas: "${currentText}". IMPORTANTE: Responda APENAS com o conteúdo reorganizado, sem introduções ou explicações adicionais.`,
      `Crie um modelo estrutural padrão para este conteúdo com agrupamento temático e sequência didática: "${currentText}". IMPORTANTE: Responda APENAS com o modelo estrutural, sem introduções ou explicações adicionais.`
    ];
    
    try {
      const suggestions = [];
      for (let i = 0; i < prompts.length; i++) {
        const result = await this.callAiApi(prompts[i]);
        suggestions.push({
          title: `${i === 0 ? 'Estrutura com Tópicos' : i === 1 ? 'Reorganização Temática' : 'Modelo Estrutural'}`,
          text: result
        });
      }
      this.setState({ "ia_script_suggestions": suggestions });
    } catch (error) {
      console.error('Erro ao gerar sugestões:', error);
    }
    
    this.setState({ "ia_render_text_modal_preloader": false });
  }

  onApplyScript(scriptText) {
    this.updateElementText(scriptText);
    this.onCloseOrganizeScript();
  }

  onOpenActivities(element) {
    this.setState({
      "current_object_id": element.id,
      "render_activities": true
    });
  }

  onCloseActivities() {
    this.setState({
      "current_object_id": null,
      "render_activities": false
    });
  }

  async onSubmitIaText() {
    this.setState({
      "ia_render_text_modal_preloader": true
    });

    var model = "response";

    var _this = this;
    var connectors = JSON.parse(window.localStorage.getItem("rdp-composer-active-project")).connectors;
    var aiConnectorUid = connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    var userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    var apiUrl = `https://${RDP_CONFIG.domain}/insights/v1.1/generative/connector/uid/${aiConnectorUid}/${model}`
    
    var prompt = document.getElementById("rdp-composer-ia-input").value;

    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${userData.access_token}`,
        "Api-Env": RDP_CONFIG.apiEnv,
        "Project-Key": RDP_CONFIG.projectKey
      },
      body: JSON.stringify({
        "prompt": `Me escreva um texto com tags html, sem markdown, sem 3 aspas iniciais, sem menção a código na estrutura de texto, e nem instruções para inserção de imagens, com quebras de linhas utilizando <br> quando necessário, sem nenhum texto antes do título, sobre '${prompt}'`
      })
    };

    var composition = this.state.composition;
    var structure = composition.structure;


    let decoder = new TextDecoder();
    let result = "";

    const response = await fetch(apiUrl, options);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const reader = response.body.getReader();

    // var obj = {};
    // obj[state] = "";


    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      for (var i = 0; i < structure.length; i++) {
        if (structure[i].id === this.state.ia_element.id) {
          structure[i].text = `<p><span style="font-size: 18px;">${result += decoder
            .decode(value, { stream: true })
            .replace(/(\r?\n|\r)/g, "")
            .replace(/\s+/g, " ")}
          </span></p>`
        }
      };

      // if (this.state.ai_doubt_identity === mathRandom) {
      //   // result += decoder.decode(value, { stream: true });
      //   // result += decoder.decode(value, { stream: true }).replace(/\r?\n|\r/g, " ");
        
      //   obj[state] = result;
      //   _this.setState(obj)
      // }
    }

    // if (this.state.ai_doubt_identity === mathRandom) {
    //   return {"finished": true};  
    // }

    // const responseAi = await axios.post(`http://localhost:3000/api/openai`, {
    //   "text": document.getElementById("rdp-composer-ia-input").value
    // });

    // for (var i = 0; i < structure.length; i++) {
    //   if (structure[i].id === this.state.ia_element.id) {
    //     structure[i].text = `<p><span style="font-size: 18px;">${responseAi.data.result}</span></p>`
    //   }
    // };
    
    composition.structure = structure;

    this.setState({
      "composition": composition,
      "ia_render_text_modal_preloader": false
    })
  }

  htmlToText(html) {
    var div = document.createElement("div");
    div.innerHTML = html;
    var text = div.textContent || div.innerText || "";
    return text;
  }

  getCompositionText() {
    var _this = this;
    var str = "";
    var composition = this.state.composition;
    var structure = composition.structure;

    for (var i = 0; i < structure.length; i++) {
      if (structure[i].type.search("text") > -1) {
        if (i > 0) {
          str += ". ";
        };
        str += _this.htmlToText(structure[i].text)
      }
    }
    
    return str.replace(" .");
  }

  cleanToSingleLine(input) {
    return input
      .replace(/\s*\n\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  cleanMarkdown(input) {
    const trimmed = input.trim();

    if (trimmed.startsWith("```")) {
      return trimmed.replace(/^```(\n|)json(\n|)/, "").replace(/\n```$/, "").trim();
    }
    return trimmed;
  }

  async onSubmitIaQuiz() {
    this.setState({
      "ia_render_quiz_modal_preloader": true
    });
    var composition = this.state.composition;
    var structure = composition.structure;

    // composition
    // theme
    // text-base

    var questionsLength = this.state.ia_quiz_questions_length;
    var questionContext = this.state.ia_quiz_question_context;

    var text = "";
    if (questionContext === "composition") {
      text = this.getCompositionText();
    } else if (questionContext === "theme") {
      text = this.iaQuizContentInput.current.value;
    } else if (questionContext === "text-base") {
      text = this.iaQuizContentTextarea.current.value;

    }

    var command;
    if (questionContext === "composition" || questionContext === "text-base") {
      command = `Me gere um questionário com ${questionsLength} questões com base no texto a seguir: '${text}', em formato JSON, dentro da chave 'questions', sendo que em cada item do array a pergunta da questão seja inserida no atributo 'question' e as alternativas estarão em um array 'choices' com os atributos: 'correct', que receberá um booleano true caso a alternativa seja correta e false caso a alternativa seja incorreta e 'text' com o texto da alternativa`;
    } else if (questionContext === "theme") {
      command = `Me gere um questionário com ${questionsLength} questões com base no tema a seguir: '${text}', em formato JSON, dentro da chave 'questions', sendo que em cada item do array a pergunta da questão seja inserida no atributo 'question' e as alternativas estarão em um array 'choices' com os atributos: 'correct', que receberá um booleano true caso a alternativa seja correta e false caso a alternativa seja incorreta e 'text' com o texto da alternativa`;
    }

    var model = "response";

    var _this = this;
    var connectors = JSON.parse(window.localStorage.getItem("rdp-composer-active-project")).connectors;
    var aiConnectorUid = connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    var userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    var apiUrl = `https://${RDP_CONFIG.domain}/insights/v1.1/generative/connector/uid/${aiConnectorUid}/${model}`
    
    // var prompt = document.getElementById("rdp-composer-ia-input").value;

    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${userData.access_token}`,
        "Api-Env": RDP_CONFIG.apiEnv,
        "Project-Key": RDP_CONFIG.projectKey
      },
      body: JSON.stringify({
        "prompt": command,
        "response_mime_type" : "application/json"
      })
    };

    // const responseAi = await axios.post(`http://localhost:3000/api/openai`, {
    //   "text": command
    // });

    // let decoder = new TextDecoder();
    // let result = "";

    // const response = await fetch(apiUrl, options);

    // if (!response.ok) {
    //   throw new Error(`Erro na requisição: ${response.statusText}`);
    // }

    // const reader = response.body.getReader();

    // while (true) {
    //   const { done, value } = await reader.read();

    //   if (done) {
    //     break;
    //   }
      
    //   result += decoder.decode(value, { stream: true });
    // }

    const response = await fetch(apiUrl, options);
    const result = await response.json();

    // var questions =  JSON.parse(this.cleanToSingleLine(this.cleanMarkdown(result))).questions;
    var questions =  result.questions;

    // var questions = JSON.parse(responseAi.data.result.replace(".", "").replaceAll(":\n", "").replaceAll("\n", ""))

    // console.log(responseAi)

    for (var i = 0; i < structure.length; i++) {
      if (structure[i].id === this.state.ia_element.id) {
        structure[i].questions = [];

        for (var j = 0; j < questions.length; j++) {
          var tempChoices = [];
          var choices = questions[j].choices;
          for (var k = 0; k < choices.length; k++) {
            choices[k].id = uuidv1()
            choices[k].text = `<p><span style=\"font-size: 15px;\">${choices[k].text}</span></p>`
            tempChoices.push(choices[k])
          }

          structure[i].questions.push({
            "id": uuidv1(),
            "question": `<p><span style=\"font-size: 18px;\">${questions[j].question}</span></p>`,
            "image": null,
            "video": null,
            "answered": false,
            "feedback_default": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "feedback_correct": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "feedback_incorrect": {
              "text": null,
              "image": null,
              "video": null,
              "media_max_width": null
            },
            "no_correct_answer": false,
            "no_feedback": false,
            "choices": tempChoices
          })
          
        }
      }
    };
    
    composition.structure = structure;

    var tempComposition = JSON.parse(JSON.stringify(composition));
    tempComposition.structure = structure.filter(item => item.id !== this.state.ia_element.id);

    this.setState({
      "composition": tempComposition,
      "ia_render_quiz_modal_preloader": false,
      "ia_render_quiz_modal": false
    }, function() {
      this.setState({
        "composition": composition
      })
    })
  }

  onSelectIaQuestionsLength(numb) {
    this.setState({
      "ia_quiz_questions_length": numb
    })
  }

  onSelectIaQuestionContext(context) {
    this.setState({
      "ia_quiz_question_context": context
    })
  }

  async callAiApi(prompt) {
    var connectors = JSON.parse(window.localStorage.getItem("rdp-composer-active-project")).connectors;
    var aiConnectorUid = connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    var userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    var apiUrl = `https://${RDP_CONFIG.domain}/insights/v1.1/generative/connector/uid/${aiConnectorUid}/response`;
    
    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${userData.access_token}`,
        "Api-Env": RDP_CONFIG.apiEnv,
        "Project-Key": RDP_CONFIG.projectKey
      },
      body: JSON.stringify({ "prompt": prompt })
    };

    const response = await fetch(apiUrl, options);
    const reader = response.body.getReader();
    let decoder = new TextDecoder();
    let result = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }

    return this.cleanAiResponse(result);
  }

  cleanAiResponse(text) {
    return text
      .replace(/```[\s\S]*?```/g, '') // Remove code blocks
      .replace(/#{1,6}\s+/g, '') // Remove markdown headers
      .replace(/---+/g, '') // Remove horizontal rules
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Convert bold
      .replace(/\*(.*?)\*/g, '<em>$1</em>') // Convert italic
      .replace(/&quot;/g, '"') // Fix quotes
      .replace(/&gt;/g, '>') // Fix greater than
      .replace(/&lt;/g, '<') // Fix less than
      .replace(/&amp;/g, '&') // Fix ampersand
      .replace(/\\n/g, ' ') // Remove escaped newlines
      .replace(/\\t/g, ' ') // Remove escaped tabs
      .replace(/\\r/g, ' ') // Remove escaped carriage returns
      .replace(/\\&quot;/g, '"') // Fix escaped quotes
      .replace(/\n{2,}/g, '</p><p>') // Convert multiple line breaks to paragraphs
      .replace(/\n/g, '<br>') // Convert single line breaks to br
      .replace(/\s{2,}/g, ' ') // Normalize multiple spaces
      .replace(/^(?!<p>)/, '<p>') // Add opening paragraph if not present
      .replace(/(?!<\/p>)$/, '</p>') // Add closing paragraph if not present
      .replace(/<p>\s*<\/p>/g, '') // Remove empty paragraphs
      .replace(/<br>\s*<\/p>/g, '</p>') // Clean up br before closing p
      .replace(/<p>\s*<br>/g, '<p>') // Clean up br after opening p
      .trim();
  }

  async onIaImproveText() {
    this.setState({ "ia_render_text_modal_preloader": true });
    const currentText = this.htmlToText(this.state.ia_element.text || "");
    const prompt = `Melhore o seguinte texto mantendo o sentido original, mas tornando-o mais claro, objetivo e bem estruturado. IMPORTANTE: Responda APENAS com o texto melhorado, sem introduções, explicações ou comentários adicionais. Não use markdown, aspas triplas ou formatação especial. Use apenas texto simples que será formatado automaticamente: ${currentText}`;
    
    try {
      const result = await this.callAiApi(prompt);
      this.updateElementText(result);
    } catch (error) {
      console.error('Erro ao melhorar texto:', error);
    }
    
    this.setState({ "ia_render_text_modal_preloader": false });
  }

  async onIaAdjustClarity() {
    this.setState({ "ia_render_text_modal_preloader": true });
    const currentText = this.htmlToText(this.state.ia_element.text || "");
    const prompt = `Reescreva o seguinte texto de forma mais clara e objetiva, eliminando ambiguidades e melhorando a compreensão. IMPORTANTE: Responda APENAS com o texto reescrito, sem introduções, explicações ou comentários adicionais. Não use markdown, aspas triplas ou formatação especial. Use apenas texto simples que será formatado automaticamente: ${currentText}`;
    
    try {
      const result = await this.callAiApi(prompt);
      this.updateElementText(result);
    } catch (error) {
      console.error('Erro ao ajustar clareza:', error);
    }
    
    this.setState({ "ia_render_text_modal_preloader": false });
  }

  onIaAdaptLanguage() {
    this.onOpenAdaptLanguage();
  }

  onIaGenerateExamples() {
    this.onOpenGenerateExamples();
  }

  async onIaOrganizeContent() {
    this.setState({ "ia_render_text_modal_preloader": true });
    const compositionText = this.getCompositionText();
    const prompt = `Organize o seguinte conteúdo em um roteiro de aprendizagem estruturado com introdução, desenvolvimento e conclusão. IMPORTANTE: Responda APENAS com o conteúdo organizado, sem introduções, explicações ou comentários adicionais. Não use markdown, aspas triplas ou formatação especial. Use apenas texto simples que será formatado automaticamente: ${compositionText}`;
    
    try {
      const result = await this.callAiApi(prompt);
      this.updateElementText(result);
    } catch (error) {
      console.error('Erro ao organizar conteúdo:', error);
    }
    
    this.setState({ "ia_render_text_modal_preloader": false });
  }

  updateElementText(newText) {
    var composition = this.state.composition;
    var structure = composition.structure;
    
    for (var i = 0; i < structure.length; i++) {
      if (structure[i].id === this.state.ia_element.id) {
        structure[i].text = newText.startsWith('<p>') ? newText : `<p><span style="font-size: 18px;">${newText}</span></p>`;
      }
    }
    
    composition.structure = structure;
    this.setState({ "composition": composition });
  }

  hasElementText() {
    if (!this.state.ia_element) return false;
    const element = this.state.ia_element;
    
    // Verifica se o elemento tem texto diretamente
    if (element.text && this.htmlToText(element.text).trim().length > 0) {
      return true;
    }
    
    // Verifica se o elemento tem items com texto
    if (element.items && element.items.length > 0) {
      for (let item of element.items) {
        if (item.text && this.htmlToText(item.text).trim().length > 0) {
          return true;
        }
      }
    }
    
    // Verifica se o elemento tem questions com texto
    if (element.questions && element.questions.length > 0) {
      for (let question of element.questions) {
        if (question.question && this.htmlToText(question.question).trim().length > 0) {
          return true;
        }
      }
    }
    
    return false;
  }

  extractTextFromElement(element) {
    if (element.text) {
      return this.htmlToText(element.text);
    }
    if (element.items && element.items.length > 0) {
      return element.items.map(item => this.htmlToText(item.text || '')).join(' ');
    }
    if (element.questions && element.questions.length > 0) {
      return element.questions.map(q => this.htmlToText(q.question || '')).join(' ');
    }
    return '';
  }

  onOpenSpellcheck() {
    this.setState({
      "ia_render_spellcheck_modal": true
    }, () => {
      this.onSubmitIaSpellcheck();
    });
  }

  async onSubmitIaSpellcheck() {
    this.setState({ "ia_render_spellcheck_modal_preloader": true });
    const textContent = this.extractTextFromElement(this.state.ia_element);
    
    try {
      var connectors = JSON.parse(window.localStorage.getItem("rdp-composer-active-project")).connectors;
      var aiConnectorUid = connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
      var userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
      var apiUrl = `https://${RDP_CONFIG.domain}/insights/v1.1/generative/connector/uid/${aiConnectorUid}/response`;
      
      const options = {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${userData.access_token}`,
          "Api-Env": RDP_CONFIG.apiEnv,
          "Project-Key": RDP_CONFIG.projectKey
        },
        body: JSON.stringify({
          "prompt": `Analise o seguinte texto em português brasileiro e identifique erros de ortografia, digitação e gramática. Retorne APENAS um JSON válido no formato: {"errors": [{"word": "palavra_incorreta", "suggestions": ["sugestão1", "sugestão2", "sugestão3"], "type": "ortografia|digitacao|gramatica", "context": "contexto da palavra no texto"}]}. Se não houver erros, retorne: {"errors": []}. Texto: "${textContent}"`,
          "response_mime_type": "application/json"
        })
      };

      const response = await fetch(apiUrl, options);
      const result = await response.json();
      
      this.setState({
        "ia_spellcheck_errors": result.errors || [],
        "ia_spellcheck_text": textContent,
        "ia_render_spellcheck_modal_preloader": false
      });
    } catch (error) {
      console.error('Erro na correção ortográfica:', error);
      this.setState({
        "ia_render_spellcheck_modal_preloader": false,
        "ia_spellcheck_errors": []
      });
    }
  }

  renderIaTextWindow() {
    if (this.state.ia_render_text_modal === true) {
      return <div className="rdp-composer-ia">
        <div className="rdp-composer-ia-header">
          <span className="rdp-composer-ia-header-title">Assistente de IA</span>
          <span className="rdp-composer-ia-header-close" onClick={() => this.onCloseIa()}></span>
        </div>
        <div className="rdp-composer-ia-body">
          <div className="rdp-composer-ia-actions">
            <button className="rdp-composer-ia-action-btn" onClick={() => this.onOpenCreateText()}>{this.state.labels.ai_tools.create_text_title}</button>
            <button className="rdp-composer-ia-action-btn" onClick={() => this.onIaImproveText()}>{this.state.labels.ai_tools.improve_text_title}</button>
            {this.hasElementText() && <button className="rdp-composer-ia-action-btn" data-action="spellcheck" onClick={(e) => { e.preventDefault(); console.log('Spell check clicked'); this.onOpenSpellcheck(); }}>{this.state.labels.ai_tools.spellcheck_title}</button>}
            <button className="rdp-composer-ia-action-btn" onClick={() => this.onIaAdjustClarity()}>{this.state.labels.ai_tools.adjust_clarity_title}</button>
            <button className="rdp-composer-ia-action-btn" onClick={() => this.onIaAdaptLanguage()}>{this.state.labels.ai_tools.adapt_language_title}</button>
            <button className="rdp-composer-ia-action-btn" onClick={() => this.onIaGenerateExamples()}>{this.state.labels.ai_tools.generate_examples_title}</button>
            <button className="rdp-composer-ia-action-btn" onClick={() => this.onOpenOrganizeScript()}>{this.state.labels.ai_tools.organize_script_title}</button>
          </div>
          {this.state.ia_render_create_text_modal && this.renderCreateTextModal()}
          {this.state.ia_render_adapt_language_modal && this.renderAdaptLanguageModal()}
          {this.state.ia_render_generate_examples_modal && this.renderGenerateExamplesModal()}
          {this.state.ia_render_organize_script_modal && this.renderOrganizeScriptModal()}
          {this.state.ia_render_spellcheck_modal && this.renderSpellcheckModal()}

        </div>
        {(this.state.ia_render_text_modal_preloader === true || this.state.ia_render_spellcheck_modal_preloader === true) &&
          <div className="rdp-composer-ia-preloader"></div>
        }
      </div>
    }
  }

  renderCreateTextModal() {
    return <div className="rdp-composer-ia-create-text-modal">
      <div className="rdp-composer-ia-create-text-header">
        <span className="rdp-composer-ia-create-text-title">{this.state.labels.ai_tools.create_text_title}</span>
        <span className="rdp-composer-ia-create-text-close" onClick={() => this.onCloseCreateText()}></span>
      </div>
      <div className="rdp-composer-ia-create-text-body">
        <div className="rdp-composer-ia-description">
          <span className="rdp-composer-ia-description-title">Exemplos de uso:</span>
          <ul className="rdp-composer-ia-description-items">
            <li className="rdp-composer-ia-description-item">
              Me escreva um texto sobre estratégias de Marketing Digital.
            </li>
            <li className="rdp-composer-ia-description-item">
              Me escreva um parágrafo explicando sobre Compliance.
            </li>
            <li className="rdp-composer-ia-description-item">
              Quais os efeitos colaterais do cigarro eletrônico?
            </li>
            <li className="rdp-composer-ia-description-item">
              Me escreva uma lista dos benefícios da água com limão.
            </li>
          </ul>
        </div>
        <div className="rdp-composer-ia-field">
          <textarea id="rdp-composer-ia-input" type="text" placeholder={this.state.labels.ai_tools.create_text_placeholder}/>
          <button className="rdp-composer-ia-script-generate" onClick={() => this.onSubmitIaText()}>{this.state.labels.ai_tools.create_text_button}</button>
        </div>
      </div>
    </div>
  }

  renderAdaptLanguageModal() {
    return <div className="rdp-composer-ia-adapt-language-modal">
      <div className="rdp-composer-ia-adapt-language-header">
        <span className="rdp-composer-ia-adapt-language-title">{this.state.labels.ai_tools.adapt_language_title}</span>
        <span className="rdp-composer-ia-adapt-language-close" onClick={() => this.onCloseAdaptLanguage()}></span>
      </div>
      <div className="rdp-composer-ia-adapt-language-body">
        <div className="rdp-composer-ia-adapt-options">
          <div className="rdp-composer-ia-adapt-option">
            <label>{this.state.labels.ai_tools.adapt_language_tone_label}</label>
            <select id="ia-tone">
              <option value="formal">{this.state.labels.ai_tools.adapt_language_tone_formal}</option>
              <option value="informal">{this.state.labels.ai_tools.adapt_language_tone_informal}</option>
              <option value="neutro">{this.state.labels.ai_tools.adapt_language_tone_neutral}</option>
            </select>
          </div>
          <div className="rdp-composer-ia-adapt-option">
            <label>{this.state.labels.ai_tools.adapt_language_complexity_label}</label>
            <select id="ia-complexity">
              <option value="simples">{this.state.labels.ai_tools.adapt_language_complexity_simple}</option>
              <option value="intermediário">{this.state.labels.ai_tools.adapt_language_complexity_intermediate}</option>
              <option value="avançado">{this.state.labels.ai_tools.adapt_language_complexity_advanced}</option>
            </select>
          </div>
          <div className="rdp-composer-ia-adapt-option">
            <label>{this.state.labels.ai_tools.adapt_language_target_label}</label>
            <input type="text" id="ia-target" placeholder={this.state.labels.ai_tools.adapt_language_target_placeholder}/>
          </div>
          <button className="rdp-composer-ia-adapt-generate" style={{background: "#6f42c1"}} onClick={() => {
            const tone = document.getElementById('ia-tone').value;
            const complexity = document.getElementById('ia-complexity').value;
            const target = document.getElementById('ia-target').value || 'público geral';
            this.onGenerateLanguageSuggestions(tone, complexity, target);
          }}>{this.state.labels.ai_tools.adapt_language_button}</button>
        </div>
        <div className="rdp-composer-ia-adapt-suggestions">
          {this.state.ia_language_suggestions.map((suggestion, index) => (
            <div key={index} className="rdp-composer-ia-suggestion">
              <h4>{suggestion.title}</h4>
              <p dangerouslySetInnerHTML={{__html: suggestion.text}}></p>
              <div className="rdp-composer-ia-suggestion-actions">
                <button onClick={() => this.onApplySuggestion(suggestion.text)}>{this.state.labels.ai_tools.suggestion_apply_button}</button>
                <button onClick={() => navigator.clipboard.writeText(this.htmlToText(suggestion.text))}>{this.state.labels.ai_tools.suggestion_copy_button}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {this.state.ia_render_text_modal_preloader && 
        <div className="rdp-composer-ia-preloader"></div>
      }
    </div>
  }

  renderGenerateExamplesModal() {
    return <div className="rdp-composer-ia-generate-examples-modal">
      <div className="rdp-composer-ia-generate-examples-header">
        <span className="rdp-composer-ia-generate-examples-title">{this.state.labels.ai_tools.generate_examples_title}</span>
        <span className="rdp-composer-ia-generate-examples-close" onClick={() => this.onCloseGenerateExamples()}></span>
      </div>
      <div className="rdp-composer-ia-generate-examples-body">
        <div className="rdp-composer-ia-examples-input">
          <label>{this.state.labels.ai_tools.generate_examples_label}</label>
          <textarea id="ia-examples-base" placeholder={this.state.labels.ai_tools.generate_examples_placeholder}></textarea>
          <button className="rdp-composer-ia-examples-generate" onClick={() => {
            const baseText = document.getElementById('ia-examples-base').value || 'exemplos práticos';
            this.onGenerateExamplesSuggestions(baseText);
          }}>{this.state.labels.ai_tools.generate_examples_button}</button>
        </div>
        <div className="rdp-composer-ia-examples-suggestions">
          {this.state.ia_examples_suggestions.map((example, index) => (
            <div key={index} className="rdp-composer-ia-suggestion">
              <h4>{example.title}</h4>
              <p dangerouslySetInnerHTML={{__html: example.text}}></p>
              <div className="rdp-composer-ia-suggestion-actions">
                <button onClick={() => this.onApplyExample(example.text)}>{this.state.labels.ai_tools.suggestion_apply_button}</button>
                <button onClick={() => navigator.clipboard.writeText(this.htmlToText(example.text))}>{this.state.labels.ai_tools.suggestion_copy_button}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {this.state.ia_render_text_modal_preloader && 
        <div className="rdp-composer-ia-preloader"></div>
      }
    </div>
  }

  renderOrganizeScriptModal() {
    return <div className="rdp-composer-ia-organize-script-modal">
      <div className="rdp-composer-ia-organize-script-header">
        <span className="rdp-composer-ia-organize-script-title">{this.state.labels.ai_tools.organize_script_title}</span>
        <span className="rdp-composer-ia-organize-script-close" onClick={() => this.onCloseOrganizeScript()}></span>
      </div>
      <div className="rdp-composer-ia-organize-script-body">
        <div className="rdp-composer-ia-script-input">
          <label>{this.state.labels.ai_tools.organize_script_context_label}</label>
          <textarea id="ia-script-context" placeholder={this.state.labels.ai_tools.organize_script_context_placeholder}></textarea>
          <button className="rdp-composer-ia-script-generate" onClick={() => {
            const context = document.getElementById('ia-script-context').value;
            this.onGenerateScriptSuggestions(context);
          }}>{this.state.labels.ai_tools.organize_script_button}</button>
        </div>
        <div className="rdp-composer-ia-script-suggestions">
          {this.state.ia_script_suggestions.map((suggestion, index) => (
            <div key={index} className="rdp-composer-ia-suggestion">
              <h4>{suggestion.title}</h4>
              <p dangerouslySetInnerHTML={{__html: suggestion.text}}></p>
              <div className="rdp-composer-ia-suggestion-actions">
                <button onClick={() => this.onApplyScript(suggestion.text)}>{this.state.labels.ai_tools.suggestion_apply_button}</button>
                <button onClick={() => navigator.clipboard.writeText(this.htmlToText(suggestion.text))}>{this.state.labels.ai_tools.suggestion_copy_button}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {this.state.ia_render_text_modal_preloader && 
        <div className="rdp-composer-ia-preloader"></div>
      }
    </div>
  }

  onApplySpellcheckCorrection(originalWord, suggestion) {
    var composition = this.state.composition;
    var structure = composition.structure;
    
    for (var i = 0; i < structure.length; i++) {
      if (structure[i].id === this.state.ia_element.id) {
        if (structure[i].text) {
          // Replace the word in the HTML text
          var updatedText = structure[i].text.replace(new RegExp(`\\b${originalWord}\\b`, 'gi'), suggestion);
          structure[i].text = updatedText;
        }
        if (structure[i].items && structure[i].items.length > 0) {
          structure[i].items.forEach(item => {
            if (item.text) {
              item.text = item.text.replace(new RegExp(`\\b${originalWord}\\b`, 'gi'), suggestion);
            }
          });
        }
        if (structure[i].questions && structure[i].questions.length > 0) {
          structure[i].questions.forEach(question => {
            if (question.question) {
              question.question = question.question.replace(new RegExp(`\\b${originalWord}\\b`, 'gi'), suggestion);
            }
          });
        }
      }
    }
    
    composition.structure = structure;
    
    // Remove the corrected error from the list
    const updatedErrors = this.state.ia_spellcheck_errors.filter(error => error.word !== originalWord);
    
    // Update the spellcheck text to reflect the change
    const updatedSpellcheckText = this.state.ia_spellcheck_text.replace(new RegExp(`\\b${originalWord}\\b`, 'gi'), suggestion);
    
    this.setState({ 
      "composition": composition,
      "ia_spellcheck_errors": updatedErrors,
      "ia_spellcheck_text": updatedSpellcheckText 
    });
  }

  onApplyAllSpellcheckCorrections() {
    this.state.ia_spellcheck_errors.forEach(error => {
      if (error.suggestions && error.suggestions.length > 0) {
        this.onApplySpellcheckCorrection(error.word, error.suggestions[0]);
      }
    });
  }

  renderSpellcheckModal() {
    return <div className="rdp-composer-ia-spellcheck-modal">
      <div className="rdp-composer-ia-spellcheck-header">
        <span className="rdp-composer-ia-spellcheck-title">Correção Ortográfica</span>
        <span className="rdp-composer-ia-spellcheck-close" onClick={() => this.onCloseSpellcheck()}></span>
      </div>
      <div className="rdp-composer-ia-spellcheck-body">
        {this.state.ia_spellcheck_errors.length === 0 && !this.state.ia_render_spellcheck_modal_preloader ? (
          <div style={{textAlign: "center", padding: "20px"}}>
            <button className="rdp-composer-ia-script-generate" style={{width: "100%"}} onClick={() => this.onSubmitIaSpellcheck()}>Verificar Ortografia</button>
          </div>
        ) : null}
        
        {this.state.ia_spellcheck_errors.length > 0 && (
          <div>
            <span className="rdp-composer-ia-description-title">Erros encontrados ({this.state.ia_spellcheck_errors.length}):</span>
            <div style={{textAlign: "center", margin: "25px 0"}}>
              <button className="rdp-composer-ia-script-generate" style={{width: "100%"}} onClick={() => this.onApplyAllSpellcheckCorrections()}>{this.state.labels.ai_tools.spellcheck_apply_all}</button>
            </div>
            <div style={{marginTop: "25px"}}>
              {this.state.ia_spellcheck_errors.map((error, index) => (
                <div key={index} style={{marginBottom: "20px", padding: "15px", border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fff"}}>
                  <div style={{marginBottom: "8px", fontWeight: "bold", color: "#dc3545"}}>
                    {error.type}: "{error.word}"
                  </div>
                  <div style={{marginBottom: "12px", color: "#666", fontSize: "14px", fontStyle: "italic"}}>
                    Contexto: {error.context}
                  </div>
                  <div>
                    <strong style={{display: "block", marginBottom: "8px", fontSize: "14px"}}>Sugestões:</strong>
                    <div style={{display: "flex", flexWrap: "wrap", gap: "8px"}}>
                      {error.suggestions && error.suggestions.map((suggestion, suggIndex) => (
                        <button 
                          key={suggIndex}
                          style={{
                            padding: "6px 12px",
                            backgroundColor: "#6f42c1",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "13px"
                          }}
                          onClick={() => this.onApplySpellcheckCorrection(error.word, suggestion)}
                        >
                          {suggestion}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{textAlign: "center", marginTop: "20px 0"}}>
              <button className="rdp-composer-ia-script-generate" style={{width: "100%"}} onClick={() => this.onSubmitIaSpellcheck()}>Verificar Novamente</button>
            </div>
          </div>
        )}
        
        {this.state.ia_spellcheck_errors.length === 0 && !this.state.ia_render_spellcheck_modal_preloader && this.state.ia_spellcheck_text && (
          <div style={{textAlign: "center", padding: "20px", color: "#28a745", fontWeight: "bold"}}>
            ✓ Nenhum erro de ortografia encontrado!
          </div>
        )}
      </div>
      {this.state.ia_render_spellcheck_modal_preloader && 
        <div className="rdp-composer-ia-preloader"></div>
      }
    </div>
  }

  renderIaQuizWindow() {
    var questionsLength = this.state.ia_quiz_questions_length;
    var questionContext = this.state.ia_quiz_question_context;
    if (this.state.ia_render_quiz_modal === true) {
      return <div className="rdp-composer-ia">
        <div className="rdp-composer-ia-header">
          <span className="rdp-composer-ia-header-title">Assistente de IA</span>
          {/* Conte com nossa ferramenta de inteligência artificial para a produção de qualquer texto */}
          <span className="rdp-composer-ia-header-close" onClick={() => this.onCloseIa()}></span>
        </div>
        <div className="rdp-composer-ia-body">
          {/* <div className="rdp-composer-ia-quiz-header">
            <span className="rdp-composer-ia-quiz-header-title">Crie seu Questionário via Inteligência Artificial</span>
            <span className="rdp-composer-ia-quiz-header-close" onClick={() => this.setState({"ia_render_quiz_modal": false})}>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="768" height="768" viewBox="0 0 768 768">
                <path fill="#3b3b3b" d="M607.5 205.5l-178.5 178.5 178.5 178.5-45 45-178.5-178.5-178.5 178.5-45-45 178.5-178.5-178.5-178.5 45-45 178.5 178.5 178.5-178.5z"></path>
              </svg>
            </span>
          </div> */}
          <div className="rdp-composer-ia-quiz-content">
            <h5>Quantas questões terá seu questionário?</h5>
            <ul className="rdp-composer-ia-quiz-content-numbers top">
              <li onClick={() => this.onSelectIaQuestionsLength(1)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 1 ? "active" : ""}`}>1</li>
              <li onClick={() => this.onSelectIaQuestionsLength(2)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 2 ? "active" : ""}`}>2</li>
              <li onClick={() => this.onSelectIaQuestionsLength(3)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 3 ? "active" : ""}`}>3</li>
              <li onClick={() => this.onSelectIaQuestionsLength(4)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 4 ? "active" : ""}`}>4</li>
              <li onClick={() => this.onSelectIaQuestionsLength(5)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 5 ? "active" : ""}`}>5</li>
              <li onClick={() => this.onSelectIaQuestionsLength(6)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 6 ? "active" : ""}`}>6</li>
              <li onClick={() => this.onSelectIaQuestionsLength(7)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 7 ? "active" : ""}`}>7</li>
              <li onClick={() => this.onSelectIaQuestionsLength(8)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 8 ? "active" : ""}`}>8</li>
              <li onClick={() => this.onSelectIaQuestionsLength(9)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 9 ? "active" : ""}`}>9</li>
              <li onClick={() => this.onSelectIaQuestionsLength(10)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 10 ? "active" : ""}`}>10</li>
              {/* <li onClick={() => this.onSelectIaQuestionsLength(11)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 11 ? "active" : ""}`}>11</li>
              <li onClick={() => this.onSelectIaQuestionsLength(12)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 12 ? "active" : ""}`}>12</li>
              <li onClick={() => this.onSelectIaQuestionsLength(13)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 13 ? "active" : ""}`}>13</li>
              <li onClick={() => this.onSelectIaQuestionsLength(14)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 14 ? "active" : ""}`}>14</li>
              <li onClick={() => this.onSelectIaQuestionsLength(15)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 15 ? "active" : ""}`}>15</li>
              <li onClick={() => this.onSelectIaQuestionsLength(16)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 16 ? "active" : ""}`}>16</li>
              <li onClick={() => this.onSelectIaQuestionsLength(17)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 17 ? "active" : ""}`}>17</li>
              <li onClick={() => this.onSelectIaQuestionsLength(18)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 18 ? "active" : ""}`}>18</li>
              <li onClick={() => this.onSelectIaQuestionsLength(19)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 19 ? "active" : ""}`}>19</li>
              <li onClick={() => this.onSelectIaQuestionsLength(20)} className={`rdp-composer-ia-quiz-content-number ${questionsLength === 20 ? "active" : ""}`}>20</li> */}
            </ul>

            <h5>Qual será a base do seu conteúdo?</h5>

            <ul className="rdp-composer-ia-quiz-content-contexts">
              <li onClick={() => this.onSelectIaQuestionContext("composition")} className={`rdp-composer-ia-quiz-content-context ${questionContext === "composition" ? "active" : ""}`}>
                <span className="rdp-composer-ia-quiz-content-context-title">Composição</span>
                <span className="rdp-composer-ia-quiz-content-context-description">
                  A inteligência artificial utilizará o conteúdo textual da composição atual como base para gerar o questionário.
                </span>
              </li>
              <li onClick={() => this.onSelectIaQuestionContext("theme")} className={`rdp-composer-ia-quiz-content-context ${questionContext === "theme" ? "active" : ""}`}>
                <span className="rdp-composer-ia-quiz-content-context-title">Tema específico</span>
                <span className="rdp-composer-ia-quiz-content-context-description">
                  Insira um tema específico para o seu questionário, por exemplo: "Álgebra", que será utilizado para a geração do questionário.
                </span>
              </li>
              <li onClick={() => this.onSelectIaQuestionContext("text-base")} className={`rdp-composer-ia-quiz-content-context ${questionContext === "text-base" ? "active" : ""}`}>
                <span className="rdp-composer-ia-quiz-content-context-title">Texto base</span>
                <span className="rdp-composer-ia-quiz-content-context-description">
                  Escreva um conteúdo textual, proporcionando uma base sólida para a geração do questionário via inteligência artificial.
                </span>
              </li>
            </ul>

            {questionContext === "theme" &&
              <>
                <h5>Escreva abaixo o tema desejado:</h5>
                <input ref={this.iaQuizContentInput} className="rdp-composer-ia-quiz-content-context-input" type="text"/>
              </>
            }

            {questionContext === "text-base" &&
              <>
                <h5>Escreva abaixo o texto base desejado:</h5>
                <textarea ref={this.iaQuizContentTextarea} className="rdp-composer-ia-quiz-content-context-textarea"/>
              </>
            }
          </div>

          <span className="rdp-composer-ia-field-submit" onClick={() => this.onSubmitIaQuiz()}>Gerar questionário</span>

          {/* <div className="rdp-composer-ia-quiz-content-footer">
            <button className="rdp-composer-ia-quiz-content-footer-submit" onClick={() => this.onSubmitIaQuiz()}>Gerar questionário</button>
          </div> */}
          
        </div>
        {this.state.ia_render_quiz_modal_preloader === true &&
            <div className="rdp-composer-ia-preloader" style={{borderRadius: "10px", height: "100%"}}></div>
          }
      </div>
    }
  }

  toggleFirstVersionItems() {
    this.setState({
      "render_first_version_items": !this.state.render_first_version_items,
    })
  }

  toggleSecondVersionItems() {
    this.setState({
      "render_second_version_items": !this.state.render_second_version_items,
    })
  }

  changeFirstVersion(uid) {
    this.setState({
      "render_first_version_items": false,
      "first_version": uid
    })
  }

  changeSecondVersion(uid) {
    this.setState({
      "render_second_version_items": false,
      "second_version": uid
    })
  }

  editComposition(uid) {
    const version = this.state.versions.find(item => item.content_uid === uid);
    if (!version) return;
    // window.location = window.location.href + "composer/" + uid
    window.location.href = window.location.origin + window.location.pathname + "#/composer/" + uid + "?file_uid=" + version.file_uid;;
    // window.location.reload();
  }

  onUpdateComposition(newComposition) {
    const _this = this;
    _this.setState({ composition: newComposition })
  }

  formatProperties(properties) {
    var temp = [];
    for (var i = 0; i < properties.length; i++) {
      temp.push({
        "uid": properties[i].uid,
        "value": properties[i].value
      });
    };
    return temp;
  }

  onChangeProcessPropertyValue(obj, uid, value) {
    var composition = this.state.composition;
    var properties = composition[`workflows_required_${obj}`].properties;
    for (var i = 0; i < properties.length; i++) {
      if (properties[i].uid === uid) {
        properties[i].value = value;
      };
    };
    composition[`workflows_required_${obj}`].properties = properties;
    this.setState({
      "composition": composition
    });
  }

  onSaveInstructions() {
    var composition = this.state.composition;
    composition.is_template = true;

    this.setState({
      "composition": composition,
      "render_composition_processes": false
    });
    // var composition = this.state.composition;
    // console.log(this.state.composition);

    // const {
    //   processes,
    //   temp_processes_selected_first,
    //   temp_processes_selected_last
    // } = this.state;

    // console.log(this.formatProperties(processes.find(item => item.uid === temp_processes_selected_first).properties));

    // composition.workflows_required_first = {
    //   "uid": temp_processes_selected_first,
    //   "properties": this.formatProperties(processes.find(item => item.uid === temp_processes_selected_first).properties)
    // };

    // composition.workflows_required_last = {
    //   "uid": temp_processes_selected_last,
    //   "properties": this.formatProperties(processes.find(item => item.uid === temp_processes_selected_last).properties)
    // };
  }

  onSelectProcess(obj, value) {
    const {
      composition,
      processes
    } = this.state;

    if (composition[`workflows_required_${obj}`] === undefined) {
      composition[`workflows_required_${obj}`] = {};
    };

    composition[`workflows_required_${obj}`].uid = value;
    composition[`workflows_required_${obj}`].properties = this.formatProperties(processes.find(item => item.uid === value).properties);

    this.setState({
      "composition": composition
    })
  }

  getPropertyDefaultValue(target, processUid, propertyUid) {
    const {
      composition
    } = this.state;

    if (target === "first" && composition.workflows_required_first && composition.workflows_required_first.uid === processUid) {
      return composition.workflows_required_first.properties.find(item => item.uid === propertyUid).value;
    };
    if (target === "last" && composition.workflows_required_last && composition.workflows_required_last.uid === processUid) {
      return composition.workflows_required_last.properties.find(item => item.uid === propertyUid).value;
    };
  }

  render() {
    const {
      versions,
      composition,
      processes,
      temp_processes_selected_first,
      temp_processes_selected_last
    } = this.state;
    var _this = this;
    var structure = composition.structure;
    var ui = composition.interface;
    var onlyEdit = this.props.match.path.search("onlyedit") > -1;
    return (
      <CompositionProvider
        onSaveComposition={() => _this.onSaveClick()}
        clearBeforeStructure={() => _this.setState({ structure_before_removed: null })}
        beforeStructure={_this.state.structure_before_removed}
        editing={_this.state.element_edit_props}
        composition={_this.state.composition}
        onChangeComposition={newComposition => _this.onUpdateComposition(newComposition)}>
        <div className={`rdp-composer-home rdp-composer-home-theme-${RDP_CONFIG['theme']} ${this.state.user_is_creator_viewer ? "disabled-text" : ""}`}>
          {this.state.render_composition_processes &&
            <div className="rdp-composer-composition-processes">
              <div className="rdp-composer-composition-processes-modal">
                <div className="rdp-composer-composition-processes-modal-header">
                  <span className="rdp-composer-composition-processes-modal-header-title">Adicionar Processos</span>
                  <span className="rdp-composer-composition-processes-modal-header-close" onClick={() => {
                    this.setState({
                      "render_composition_processes": false
                    })
                  }}></span>
                </div>
                <div className="rdp-composer-composition-processes-modal-columns">
                  <div className="rdp-composer-composition-processes-modal-column">
                    <div className="rdp-composer-composition-processes-modal-column-group">
                      <span className="rdp-composer-element-activities-workflows-process-label">Processo Inicial</span>
                      {processes &&
                        <>
                          <select className="rdp-composer-element-activities-workflow-message-select"
                            defaultValue={temp_processes_selected_first}
                            style={{marginTop: "5px", backgroundImage: "unset"}}
                            placeholder="Selecione um processo cadastrado"
                            onChange={(e) => {
                              _this.onSelectProcess("first", e.target.value);
                              _this.setState({
                                "temp_processes_selected_first": e.target.value
                              })
                            }}
                          >
                            <option disabled selected value="">Selecione um processo cadastrado</option>
                            {processes.map(function(proc, index) {
                              return <option key={index} value={proc.uid}>{proc.name}</option>
                            })}
                          </select>
                          {temp_processes_selected_first && processes.find(proc => proc.uid === temp_processes_selected_first) &&
                            <div>
                              {processes.find(proc => proc.uid === temp_processes_selected_first).properties.length > 0 &&
                                <>
                                  <span className="rdp-composer-element-activities-workflows-processes-title">Informações Exigidas Pelo Processo</span>
                                  <p className="rdp-composer-element-activities-workflows-processes-description">
                                    Os campos abaixos são exigidos para o processo vinculado, nesta etapa você pode pré-prencher ou deixar em branco para ser preenchido na solicitação da demanda.
                                  </p>
                                </>
                              }
                              {processes.find(proc => proc.uid === temp_processes_selected_first).properties.map(function (property, index) {
                                return <div key={index} className="rdp-composer-element-activities-workflows-process">
                                  <span className="rdp-composer-element-activities-workflows-process-label">{property.name}</span>
                                  {property.type === "Text" &&
                                    <input type="text" key={`${temp_processes_selected_first}-${property.uid}`} defaultValue={_this.getPropertyDefaultValue("first", temp_processes_selected_first, property.uid)} className="rdp-composer-element-activities-workflows-process-input" onChange={(e) => _this.onChangeProcessPropertyValue("first", property.uid, e.target.value)}/>
                                  }
                                  {property.type === "DateTime" &&
                                    <input type="date" key={`${temp_processes_selected_first}-${property.uid}`} defaultValue={_this.getPropertyDefaultValue("first", temp_processes_selected_first, property.uid)} className="rdp-composer-element-activities-workflows-process-input" onChange={(e) => _this.onChangeProcessPropertyValue("first", property.uid, e.target.value)}/>
                                  }
                                </div>
                              })}
                            </div>
                          }
                        </>
                      }
                      {/* <div className="rdp-composer-element-activities-workflow-message-select" style={{marginTop: "5px"}}>Selecione um processo cadastrado</div> */}
                    </div>
                  </div>
                  <div className="rdp-composer-composition-processes-modal-column">
                    <div className="rdp-composer-composition-processes-modal-column-group">
                      <span className="rdp-composer-element-activities-workflows-process-label">Processo Final</span>
                      {processes &&
                        <>
                          <select className="rdp-composer-element-activities-workflow-message-select"
                            defaultValue={temp_processes_selected_last}
                            style={{marginTop: "5px", backgroundImage: "unset"}}
                            placeholder="Selecione um processo cadastrado"
                            onChange={(e) => {
                              _this.onSelectProcess("last", e.target.value);
                              _this.setState({
                                "temp_processes_selected_last": e.target.value
                              })
                            }}
                          >
                            <option disabled selected value="">Selecione um processo cadastrado</option>
                            {processes.map(function(proc, index) {
                              return <option key={index} value={proc.uid}>{proc.name}</option>
                            })}
                          </select>
                          {temp_processes_selected_last && processes.find(proc => proc.uid === temp_processes_selected_last) &&
                            <div>
                              {processes.find(proc => proc.uid === temp_processes_selected_last).properties.length > 0 &&
                                <>
                                  <span className="rdp-composer-element-activities-workflows-processes-title">Informações Exigidas Pelo Processo</span>
                                  <p className="rdp-composer-element-activities-workflows-processes-description">
                                    Os campos abaixos são exigidos para o processo vinculado, nesta etapa você pode pré-prencher ou deixar em branco para ser preenchido na solicitação da demanda.
                                  </p>
                                </>
                              }
                              {processes.find(proc => proc.uid === temp_processes_selected_last).properties.map(function (property, index) {
                                return <div key={index} className="rdp-composer-element-activities-workflows-process">
                                  <span className="rdp-composer-element-activities-workflows-process-label">{property.name}</span>
                                  {property.type === "Text" &&
                                    <input type="text" key={`${temp_processes_selected_last}-${property.uid}`} defaultValue={_this.getPropertyDefaultValue("last", temp_processes_selected_last, property.uid)} className="rdp-composer-element-activities-workflows-process-input" onChange={(e) => _this.onChangeProcessPropertyValue("last", property.uid, e.target.value)}/>
                                  }
                                  {property.type === "DateTime" &&
                                    <input type="date" key={`${temp_processes_selected_last}-${property.uid}`} defaultValue={_this.getPropertyDefaultValue("last", temp_processes_selected_last, property.uid)} className="rdp-composer-element-activities-workflows-process-input" onChange={(e) => _this.onChangeProcessPropertyValue("last", property.uid, e.target.value)}/>
                                  }
                                </div>
                              })}
                            </div>
                          }
                        </>
                      }
                    </div>
                  </div>
                </div>
                <div className="rdp-composer-composition-processes-modal-footer">
                  <button className={`rdp-composer-composition-processes-modal-footer-btn ${(temp_processes_selected_first !== null && temp_processes_selected_last !== null) ? "active": ""}`} onClick={() => this.onSaveInstructions()}>Salvar instruções</button>
                </div>
              </div>
            </div>
          }
          {this.state.render_versions_history &&
            <div className="rdp-composer-versions-history">
              <div className="rdp-composer-versions-history-header">
                <span class="rdp-composer-sidebar-back" onClick={() => this.setState({"render_versions_history": false})}>Voltar</span>
                <div className="rdp-composer-versions-history-header-item">
                  <button className={`rdp-composer-versions-history-header-item-selected ${this.state.render_first_version_items ? "opened" : ""}`} onClick={() => this.toggleFirstVersionItems()}>
                    {versions.find(item => item.content_uid === this.state.first_version).label}
                  </button>
                  <span className="rdp-composer-versions-history-header-item-edit" onClick={() => this.editComposition(versions.find(item => item.content_uid === this.state.first_version).content_uid)}></span>
                  {this.state.render_first_version_items &&
                    <ul className="rdp-composer-versions-history-header-item-versions">
                      {versions.map(function(version, index) {
                        return <li className="rdp-composer-versions-history-header-item-version" key={index} onClick={() => _this.changeFirstVersion(version.content_uid)}>{version.label}</li>
                      })}
                    </ul>
                  }
                </div>
                <div className="rdp-composer-versions-history-header-item">
                  <button className={`rdp-composer-versions-history-header-item-selected ${this.state.render_second_version_items ? "opened" : ""}`} onClick={() => this.toggleSecondVersionItems()}>
                    {versions.find(item => item.content_uid === this.state.second_version).label}
                  </button>
                  <span className="rdp-composer-versions-history-header-item-edit" onClick={() => this.editComposition(versions.find(item => item.content_uid === this.state.second_version).content_uid)}></span>
                  {this.state.render_second_version_items &&
                    <ul className="rdp-composer-versions-history-header-item-versions">
                      {versions.map(function(version, index) {
                        return <li className="rdp-composer-versions-history-header-item-version" key={index} onClick={() => _this.changeSecondVersion(version.content_uid)}>{version.label}</li>
                      })}
                    </ul>
                  }
                </div>
              </div>
              <div className="rdp-composer-versions-history-columns">
                <div className="rdp-composer-versions-history-column">
                  <iframe title="Versão Coluna 1" src={this.getIframeSrc(this.state.first_version)}></iframe>
                </div>
                <div className="rdp-composer-versions-history-column">
                  <iframe title="Versão Coluna 2" src={this.getIframeSrc(this.state.second_version)}></iframe>
                </div>
              </div>
            </div>
          }
          {this.renderDownloadingPackage()}
          {this.renderPreloader()}
          {this.renderElementEdit()}
          {this.renderElementMessages()}
          {this.renderConfigurations()}
          {this.renderGoogleFonts()}
          {this.renderIaTextWindow()}
          {this.renderIaQuizWindow()}
          <Sidebar
            onBackClick={() => this.onBackClick()}
            openedMenu={this.state.opened_menu}
            onClickSubitem={(type) => this.onClickSubitem(type)}
            onApplyTemplate={(templateObj) => this.onApplyTemplate(templateObj)}
            onSaveClick={() => this.handleSaveComposition(onlyEdit)}
            onVersionsHistoryClick={() => this.onVersionsHistoryClick()}
            onConfigurationClick={() => this.onConfigurationClick()}
            onPreviewClick={() => this.onPreviewClick()}
            previewEnabled={this.props.match.params.content_uid !== undefined}
            onZipExport={this.state.can_download ? (previousErrorResolved) => this.onZipExport(previousErrorResolved) : null}
            onToggleMenu={() => this.onToggleMenu()}
            labels={this.state.labels}
            isEmbed={this.state.is_embed}
            composition={this.state.composition}
            openedHelp={this.state.opened_help}
            onProcessesClick={() => this.onProcessesClick()}
            toggleIsTemplate={(bool) => this.toggleIsTemplate(bool)}
            onToggleHelp={() => this.onToggleHelp()}
            canEditComposition={this.state.can_edit_composition && !this.state.user_is_creator_viewer && !this.state.user_is_creator_colaborator}
            isTemplate={this.state.composition.is_template}
            enabledWorkflows={this.state.enabled_workflows}
            openedAi={this.state.ia_render_text_modal || this.state.ia_render_quiz_modal}
            isUserCreatorColaborator={this.state.user_is_creator_colaborator}
            isUserCreatorViewer={this.state.user_is_creator_viewer}
          />
          <Compositions
            editable={true}
            composition={this.state.composition}
            structure={structure}
            ui={ui}
            labels={this.state.labels}
            renderObjectMessages={this.state.can_send_object_messages}
            textEditable={this.state.can_edit_text}
            openedHelp={this.state.opened_help}
            onElementOpenMessages={(element) => this.onElementOpenMessages(element)}
            onElementCopy={(element, index) => this.onElementCopy(element, index)}
            onElementEdit={(element) => this.onElementEdit(element)}
            onElementRemove={(element) => this.onElementRemove(element)}
            onElementMoveUp={(index) => this.onElementMoveUp(index)}
            onElementMoveDown={(index) => this.onElementMoveDown(index)}
            onContentChange={(index, content) => this.onContentChange(index, content)}
            onElementAdd={(index) => this.onElementAdd(index)}
            onIa={(element, index) => this.onIa(element, index)}
            onOpenActivities={(element, index) => this.onOpenActivities(element, index)}
            canEditComposition={this.state.can_edit_composition && !this.state.user_is_creator_viewer}
            canEditVideo={this.state.can_edit_video}
            canEditAudio={this.state.can_edit_audio}
            canEditImage={this.state.can_edit_image}
            canEditText={this.state.can_edit_text}
            enabledWorkflows={this.state.enabled_workflows}
            openedAi={this.state.ia_render_text_modal || this.state.ia_render_quiz_modal}
            isUserCreatorColaborator={this.state.user_is_creator_colaborator}
            isUserCreatorViewer={this.state.user_is_creator_viewer}
          />
        </div>
      </CompositionProvider>
    );
  }
}
